<style>
  :host {
    --bright-blue: oklch(51.01% 0.274 263.83);
    --electric-violet: oklch(53.18% 0.28 296.97);
    --gray-900: oklch(19.37% 0.006 300.98);
    --gray-400: oklch(70.9% 0.015 304.04);

    font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }

  main {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0 0 1.5rem;
    min-height: 0;
    box-sizing: border-box;
  }

  .app-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 22px 2rem 0;
  }

  main > div:first-child {
    padding: 0 0 0 0;
    margin-top: 20px;
  }

  .section-wrapper {
    display: grid;
    grid-template-columns: 1fr minmax(0, calc(40% - 200px));
    gap: 1.5rem;
    align-items: stretch;
    transition: grid-template-columns 0.3s ease;
  }

  /* Hide help sections when help is disabled */
  main.help-hidden .section-wrapper {
    grid-template-columns: 1fr 0;
    align-items: start;
  }

  main.help-hidden .help-section {
    display: none !important;
  }

  main.help-hidden .help-section {
    opacity: 0;
    width: 0;
    min-width: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
    pointer-events: none;
  }

  .section-wrapper > :last-child:empty {
    display: none;
  }

  .calculator-container {
    background: white;
    border-radius: 0.5rem;
    padding: 1.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-height: auto;
    min-width: 0;
    overflow: visible;
  }



  .help-section {
    background: linear-gradient(135deg, #f0f4f8 0%, #e8f0f8 100%);
    border-left: 4px solid var(--bright-blue);
    border-radius: 0.5rem;
    padding: 1.25rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    overflow: hidden;
    min-width: 0;
    height: 100%;
    transition: opacity 0.3s ease, width 0.3s ease, padding 0.3s ease;
  }

  .help-section.collapsed {
    display: none !important;
  }

  .help-section-title {
    font-weight: 600;
    color: var(--bright-blue);
    margin: 0 0 1rem 0;
    font-size: 0.95rem;
  }

  .help-content {
    font-size: 0.875rem;
    line-height: 1.6;
    color: #444;
  }

  .help-content p {
    margin: 0 0 0.75rem 0;
  }

  .help-content ul {
    margin: 0;
    padding-left: 1.25rem;
  }

  .help-content li {
    margin-bottom: 0.5rem;
  }

  /* Mobile Help - Info Buttons & Tooltips */
  .info-btn {
    display: none; /* Hidden on desktop */
    background: var(--bright-blue);
    color: white;
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    margin-left: 6px;
    padding: 0;
    line-height: 20px;
    text-align: center;
    flex-shrink: 0;
    transition: all 0.2s ease;
  }

  .info-btn:hover {
    background: #2563eb;
    transform: scale(1.1);
  }

  .info-btn:active {
    transform: scale(0.95);
  }

  .tooltip-overlay {
    display: none; /* Hidden by default */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9998;
    animation: fadeIn 0.2s ease;
  }

  .tooltip-overlay.active {
    display: block;
  }

  .tooltip-content {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-radius: 16px 16px 0 0;
    padding: 1.5rem;
    max-height: 70vh;
    overflow-y: auto;
    z-index: 9999;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
    animation: slideUp 0.3s ease;
  }

  .tooltip-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e5e7eb;
  }

  .tooltip-title {
    font-weight: 600;
    color: var(--bright-blue);
    font-size: 1.1rem;
    margin: 0;
  }

  .tooltip-close {
    background: #f3f4f6;
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    transition: all 0.2s ease;
  }

  .tooltip-close:hover {
    background: #e5e7eb;
    color: #374151;
  }

  .tooltip-text {
    font-size: 0.95rem;
    line-height: 1.6;
    color: #444;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
  }

  /* Warning Toast Modal Styling */
  .warning-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(220, 38, 38, 0.3);
    z-index: 9998;
    animation: fadeIn 0.2s ease;
  }

  .warning-overlay.active {
    display: block;
  }

  .warning-content {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-radius: 16px 16px 0 0;
    padding: 1.5rem;
    max-height: 70vh;
    overflow-y: auto;
    z-index: 9999;
    box-shadow: 0 -4px 12px rgba(220, 38, 38, 0.2);
    border-top: 4px solid #dc2626;
    animation: slideUp 0.3s ease;
  }

  .warning-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #fecaca;
  }

  .warning-title {
    font-weight: 700;
    color: #dc2626;
    font-size: 1.1rem;
    margin: 0;
  }

  .warning-close {
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #dc2626;
    transition: all 0.2s ease;
  }

  .warning-close:hover {
    background: #fecaca;
    color: #991b1b;
  }

  .warning-text {
    font-size: 0.95rem;
    line-height: 1.6;
    color: #444;
  }

  /* Mobile responsiveness - hide desktop help, show mobile info buttons */
  @media (max-width: 768px) {
    .section-wrapper {
      grid-template-columns: 1fr; /* Stack sections vertically */
    }

    .help-section {
      display: none !important; /* Hide desktop help section on mobile */
    }

    .help-toggle-icon {
      display: none !important; /* Hide help toggle button on mobile */
    }

    .info-btn {
      display: inline-flex; /* Show info buttons on mobile */
      align-items: center;
      justify-content: center;
    }

    /* Preserve legacy flex-wrap behavior for grid labels
       (previously provided by a global 'label' rule that was
       otherwise fully overridden - see phase 3a cleanup). */
    .rental-price-grid label,
    .income-grid label {
      flex-wrap: wrap;
    }
  }

  @media (max-width: 1920px) {
    label {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 1800px) {
    label {
      font-size: 0.875rem;
    }
  }

  @media (max-width: 1600px) {
    label {
      font-size: 0.85rem;
    }
  }

  @media (max-width: 1024px) {
    .app-scroll {
      padding: 22px 1.5rem 0;
    }

    .form-help-pair {
      grid-template-columns: 1fr;
    }

    .help-sidebar {
      display: none;
    }

    .calculator-container:nth-child(2) {
      position: static;
      max-height: none;
    }

    label {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 600px) {
    .app-scroll {
      padding: 22px 1rem 0;
      gap: 1rem;
    }

    .calculator-container {
      padding: 1.5rem;
    }

    label {
      font-size: 0.8rem;
    }
  }

  .section-wrapper:first-of-type .calculator-container {
    background: transparent;
    box-shadow: none;
    padding: 0;
    gap: 0.4rem;
  }

  h1 {
    font-size: 2rem;
    color: var(--gray-900);
    margin: 0;
    margin-top: -20px;
    padding-left: 50px;
    text-align: left;
    line-height: 1.1;
  }

  .section-wrapper:first-of-type p {
    margin: 0 !important;
  }

  .form-group {
    margin-bottom: 1.5rem;
  }

  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: var(--gray-900);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e0e0e0;
    border-radius: 0.375rem;
    font-size: 1rem;
    box-sizing: border-box;
    transition: border-color 0.3s;
  }

  input:focus {
    outline: none;
    border-color: var(--bright-blue);
    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.1);
  }

  input::placeholder {
    font-size: 0.875rem;
    opacity: 0.7;
  }

  input[readonly] {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }

  .narrow-input {
    width: 75px;
    min-width: 75px;
  }

  select {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e0e0e0;
    border-radius: 0.375rem;
    font-size: 1rem;
    box-sizing: border-box;
    transition: border-color 0.3s;
    background-color: white;
    cursor: pointer;
  }

  select:focus {
    outline: none;
    border-color: var(--bright-blue);
    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.1);
  }

  select:disabled {
    background-color: #f9f9f9;
    color: #999;
    cursor: not-allowed;
  }

  .total-income-field {
    background-color: #f0fdf4 !important;
    border: 2px solid #86efac !important;
    color: #166534;
    font-weight: 600;
  }

  .total-income-field.negative {
    background-color: #fef2f2 !important;
    border: 2px solid #fca5a5 !important;
    color: #7f1d1d;
  }

  .credit-needed-field {
    background-color: #fffbeb !important;
    border: 2px solid #fcd34d !important;
    color: #92400e;
    font-weight: 600;
  }

  .scenarios-table {
    overflow-x: auto;
  }

  .scenarios-table table {
    width: 100%;
    border-collapse: collapse;
    font-size: 1rem;
    table-layout: fixed;
  }

  .scenarios-table th {
    background: linear-gradient(135deg, var(--bright-blue) 0%, #5B7C99 100%);
    color: white;
    padding: 0.75rem;
    text-align: left;
    font-weight: 600;
    border: 1px solid #ddd;
    font-size: 0.94rem;
  }

  .scenarios-table th:first-child {
    width: calc(25% - 10px);
  }

  .scenarios-table th:nth-child(2),
  .scenarios-table th:nth-child(3),
  .scenarios-table th:nth-child(4) {
    width: 25%;
  }

  .scenarios-table td {
    padding: 0.75rem;
    border: 1px solid #ddd;
    text-align: right;
  }

  .scenarios-table td:first-child {
    text-align: left;
    background: #f8f9fa;
    font-size: 0.94rem;
  }

  .scenarios-table tr.divider td {
    border-top: 2px solid var(--bright-blue);
    padding-top: 1rem;
    margin-top: 0.5rem;
  }

  .scenarios-table tr.scenario-info td {
    background: #e3f2fd;
    font-style: italic;
    color: #1565c0;
  }

  .scenarios-table tr.scenario-info td:not(:first-child) {
    font-weight: 600;
  }

  .scenarios-table tr.total-row td {
    background: #f0f4f8;
    font-weight: 700;
    font-size: 1rem;
    border-top: 3px solid var(--bright-blue);
  }

  .scenarios-table .positive {
    color: #166534;
    font-weight: 600;
  }

  .scenarios-table .negative {
    color: #991b1b;
    font-weight: 600;
  }

  .scenarios-table tbody tr:hover {
    background: #f9fafb;
  }

  /* Accordion styles for mobile scenarios comparison */
  .scenarios-accordion {
    display: none;
  }

  .accordion-item {
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 0.375rem;
    overflow: hidden;
  }

  .accordion-header {
    background: linear-gradient(135deg, var(--bright-blue) 0%, #5B7C99 100%);
    color: white;
    padding: 1rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    border: none;
    width: 100%;
    text-align: left;
  }

  .accordion-header > span {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  .accordion-header .info-btn {
    background: rgba(255, 255, 255, 0.3);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.5);
    margin: 0;
    flex-shrink: 0;
  }

  .accordion-header .info-btn:hover {
    background: rgba(255, 255, 255, 0.5);
    border-color: white;
  }

  .accordion-header:hover {
    background: linear-gradient(135deg, #5B7C99 0%, #3d5270 100%);
  }

  .accordion-header::after {
    content: '▼';
    display: inline-block;
    transition: transform 0.3s ease;
    font-size: 0.8rem;
  }

  .accordion-item.expanded .accordion-header::after {
    transform: rotate(-180deg);
  }

  .accordion-content {
    display: none;
    padding: 1rem;
    background: white;
  }

  .accordion-item.expanded .accordion-content {
    display: block;
  }

  .accordion-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid #eee;
  }

  .accordion-row:last-child {
    border-bottom: none;
  }

  .accordion-row-label {
    font-weight: 500;
    color: #333;
    flex: 1;
  }

  .accordion-row-value {
    text-align: right;
    font-weight: 500;
    color: #555;
  }

  .accordion-row.divider {
    border-top: 2px solid var(--bright-blue);
    padding-top: 1rem;
    margin-top: 0.5rem;
    font-weight: 600;
  }

  .accordion-row-value.positive {
    color: #166534;
    font-weight: 600;
  }

  .accordion-row-value.negative {
    color: #991b1b;
    font-weight: 600;
  }

  .scenarios-table .operator {
    color: var(--bright-blue);
    font-weight: 700;
    margin-right: 0.5rem;
  }

  .scenarios-table input {
    font-size: 1rem;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    max-width: 100%;
    overflow: hidden;
  }

  .price-per-sqm-field {
    background-color: #f3f4f6 !important;
    border: 2px solid #d1d5db !important;
    color: #374151;
    font-weight: 600;
  }

  button {
    width: 100%;
    padding: 0.75rem;
    background: linear-gradient(90deg, var(--bright-blue), var(--electric-violet));
    color: white;
    border: none;
    border-radius: 0.375rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.3s, transform 0.2s;
    margin-top: 1rem;
  }

  button:hover:not(:disabled) {
    opacity: 0.9;
  }

  button:active:not(:disabled) {
    transform: scale(0.98);
  }

  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .error {
    color: #ef4444;
    font-size: 0.875rem;
    margin-top: 0.5rem;
  }

  .success {
    color: #10b981;
    font-size: 0.875rem;
    margin-top: 0.5rem;
  }

  .section-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--gray-900);
    margin: 0 0 1rem 0;
    border-bottom: 2px solid var(--bright-blue);
    padding-bottom: 0.5rem;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    transition: opacity 0.2s ease;
    gap: 0.5rem;
    padding-left: 0;
    width: 100%;
    box-sizing: border-box;
    background: none !important;
    border: none !important;
    padding: 0 !important;
    font-family: inherit;
    text-align: left;
  }

  .section-title:hover {
    opacity: 0.7;
  }

  .section-title::before {
    content: '▼';
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    pointer-events: none;
  }

  .section-title.collapsed::before {
    transform: rotate(-90deg);
  }

  .price-fields-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 1rem;
    margin-bottom: 0rem;
  }

  /* Mobile: show accordion + hide table + shrink price-fields-grid */
  @media (max-width: 900px) {
    .scenarios-table {
      display: none !important;
    }

    .scenarios-accordion {
      display: block !important;
    }

    .price-fields-grid {
      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    }
  }

  /* Small screens (≤400px): shrink scenario accordion labels, values, inputs + AI buttons */
  @media (max-width: 400px) {
    /* Werte unter die Labels stapeln (statt daneben) */
    .accordion-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.25rem;
    }

    .accordion-row-label {
      font-size: 10pt;
    }

    .accordion-row-value {
      font-size: 10pt;
      text-align: left;
      width: 100%;
    }

    /* Input-Feld schmaler + kleiner */
    .accordion-row-value input {
      font-size: 10pt !important;
      width: 48px !important;
      padding: 0.15rem !important;
    }

    /* KI-Button etwas kleiner */
    .accordion-row-value .ai-button {
      min-width: 30px;
      min-height: 30px;
      font-size: 14px;
    }

    .accordion-row-value .ai-button span {
      font-size: 15px;
    }
  }

  @media (max-width: 768px) {
    .price-fields-grid {
      grid-template-columns: 1fr;
    }
  }

  .rental-price-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    margin-bottom: 0rem;
  }

  .objekt-einnahmen-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(280px, 100%), 1fr));
    gap: 1rem;
    margin-bottom: 0rem;
  }

  .objekt-einnahmen-grid .form-group {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    margin-bottom: 0 !important;
    box-sizing: border-box !important;
  }

  .rental-price-grid .form-group {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    margin-bottom: 0 !important;
    box-sizing: border-box !important;
  }

  .rental-price-grid input {
    box-sizing: border-box;
  }

  .income-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    margin-bottom: 0rem;
  }

  .income-grid .form-group {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  .rental-price-grid label {
    height: 2.5rem;
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.5rem !important;
  }

  .income-grid label {
    height: 2.5rem;
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.5rem !important;
  }

  .income-grid .form-group:nth-child(1) {
  }

  .income-grid .form-group:nth-child(2) {
  }

  .income-grid input {
    text-align: right;
  }

  /* Simulations Section - 4 Spalten auf Desktop, responsive auf Mobile */
  .simulation-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
    border: 1px solid var(--bright-blue);
    border-radius: 0.375rem;
    padding: 1rem;
  }

  .simulation-grid .form-group {
    min-width: 0;
  }

  /* Mobile: Responsive umbrechen */
  @media (max-width: 1200px) {
    .simulation-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 768px) {
    .simulation-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 600px) {
    .rental-price-grid {
      grid-template-columns: 1fr;
    }

    .income-grid {
      grid-template-columns: 1fr;
      justify-items: start;
    }
  }

  .costs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 1rem;
    margin-bottom: 0rem;
  }

  @media (max-width: 900px) {
    .costs-grid {
      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    }
  }

  @media (max-width: 768px) {
    .costs-grid {
      grid-template-columns: 1fr;
    }
  }

  /* Finanzierungskosten inline grids - responsive */
  .financing-grid {
    display: grid !important;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)) !important;
    gap: 1rem !important;
    margin-bottom: 1rem !important;
  }

  @media (max-width: 900px) {
    .financing-grid {
      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)) !important;
    }
  }

  @media (max-width: 768px) {
    .financing-grid {
      grid-template-columns: 1fr !important;
    }
  }

  .address-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 1rem;
    margin-bottom: 0rem;
  }

  @media (max-width: 1200px) {
    .address-grid {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 600px) {
    .address-grid {
      grid-template-columns: 1fr;
    }
  }

  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  @media (max-width: 600px) {
    .form-row {
      grid-template-columns: 1fr;
    }
  }

  .autocomplete-wrapper {
    position: relative;
    overflow: visible;
    z-index: 100;
  }

  .suggestions-list {
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 0.375rem;
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1001;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .suggestion-item {
    padding: 0.75rem;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
  }

  .suggestion-item:hover {
    background-color: #f5f5f5;
  }

  .suggestion-item:last-child {
    border-bottom: none;
  }

  .suggestion-item strong {
    color: var(--gray-900);
    font-weight: 600;
  }

  .suggestions-loading {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    padding: 0.75rem;
    background: white;
    border: 1px solid #e0e0e0;
    border-top: none;
    border-radius: 0 0 0.375rem 0.375rem;
    color: var(--gray-700);
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    z-index: 1000;
  }

  .spinner {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid var(--bright-blue);
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .required {
    color: #ef4444;
  }

  .suggestion-detail {
    display: block;
    font-size: 0.75rem;
    color: var(--gray-700);
    margin-top: 0.25rem;
  }

  /* Disable city/address fields until previous step is completed */
  input:disabled {
    background-color: #f9f9f9;
    color: #999;
    cursor: not-allowed;
  }

  .rental-price-wrapper input {
    width: 100% !important;
  }

  .price-loading {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: var(--bright-blue);
  }

  .loading-text {
    font-weight: 500;
  }

  .price-success {
    margin-top: 0.5rem;
    padding: 0.5rem 0.75rem;
    background-color: #f0fdf4;
    border: 1px solid #86efac;
    border-radius: 0.375rem;
    color: #166534;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .price-error {
    margin-top: 0.5rem;
    padding: 0.5rem 0.75rem;
    background-color: #fef2f2;
    border: 1px solid #fca5a5;
    border-radius: 0.375rem;
    color: #991b1b;
    font-size: 0.875rem;
    font-weight: 500;
  }



  .header-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1.5rem;
    background: white !important;
    color: white;
    padding-top: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-bottom: 4rem;
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    position: relative;
    z-index: 1000;
    overflow: visible;
    min-height: 100px;
  }

  .header-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    pointer-events: none;
  }

  .header-container::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: -15px;
    height: 1px;
    background: #d1d5db;
    pointer-events: none;
    z-index: -1;
    transform: translateY(-4px);
  }

  .header-content {
    flex: 1;
    text-align: center;
    position: relative;
    transform: translateY(-9px);
    z-index: 1;
  }

  .header-content::before {
    content: '';
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 40px;
    background: linear-gradient(135deg, oklch(60% 0.3 280) 0%, oklch(45% 0.28 263.83) 100%);
    border-radius: 50%;
    opacity: 0.1;
    filter: blur(20px);
    z-index: 0;
  }

  .header-content h1 {
    background: linear-gradient(135deg, oklch(45% 0.28 263.83) 0%, oklch(60% 0.3 280) 50%, oklch(45% 0.28 263.83) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-size: 3rem;
    margin: -2px 0 -0.3rem 5px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-weight: 900;
    letter-spacing: 0px;
    position: relative;
    display: inline-block;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    margin-left: -144px !important;
    margin-top: -4px;
    transform: translateY(-5px);
  }

  .header-content p {
    color: oklch(28% 0.06 263.83);
    margin: 5px 0 0 5px !important;
    padding-bottom: 0rem;
    font-weight: 600;
    font-size: 0.75rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    line-height: 1.4;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    margin-left: -120px !important;
    margin-top: 5px !important;
    transform: translateY(-5px);
  }

  .header-content p span {
    position: relative;
  }

  .header-content p span:nth-child(1) {
    background: linear-gradient(90deg, oklch(51% 0.28 263.83), oklch(51% 0.28 263.83));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .header-content p span:nth-child(3) {
    background: linear-gradient(90deg, oklch(51% 0.28 263.83), oklch(51% 0.28 263.83));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  :host {
    --bright-blue: oklch(51.01% 0.274 263.83);
    --electric-violet: oklch(53.18% 0.28 296.97);
  }

  .header-menu {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-left: auto;
    align-self: center;
    transform: translate(-7px, -5px);
  }

  /* Help Toggle Icon Button */
  .help-toggle-icon {
    background: white;
    border: 2px solid var(--bright-blue) !important;
    cursor: pointer;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
    color: var(--bright-blue);
    width: 40px;
    height: 40px;
    box-shadow: 0 2px 8px rgba(51, 65, 85, 0.15);
    flex-shrink: 0;
    margin: 0;
    position: relative;
    top: 0;
  }

  .help-toggle-icon:focus {
    outline: none !important;
    border: 2px solid var(--bright-blue) !important;
    box-shadow: 0 2px 8px rgba(51, 65, 85, 0.15) !important;
  }

  .help-toggle-icon:active {
    outline: none !important;
    border: 2px solid var(--bright-blue) !important;
    box-shadow: 0 2px 8px rgba(51, 65, 85, 0.15) !important;
    transform: scale(0.95);
  }

  .help-toggle-icon:hover {
    box-shadow: 0 4px 12px rgba(51, 65, 85, 0.2);
  }

  .help-toggle-icon svg {
    width: 22px;
    height: 22px;
    transition: transform 0.2s ease;
  }

  .help-toggle-icon svg {
    width: 24px;
    height: 24px;
    transition: transform 0.2s ease;
  }

  .help-toggle-icon:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 16px rgba(51, 65, 85, 0.25);
  }

  .help-toggle-icon:active {
    transform: scale(0.95);
  }

  .help-toggle-icon:focus {
    outline: 2px solid var(--bright-blue);
    outline-offset: 3px;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    justify-content: flex-start;
    padding: 0;
    background: transparent;
    border: none;
    margin: 0;
    position: relative;
    z-index: 2;
  }

  .action-button {
    padding: 0.5rem 1rem;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
    background: #dbeafe;
    color: #1e40af;
    font-size: 0.8rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 1px 2px rgba(30, 64, 175, 0.05);
    display: flex;
    align-items: center;
    gap: 0.4rem;
    white-space: nowrap;
    line-height: 1;
  }

  .action-button svg {
    width: 18px;
    height: 18px;
    transition: transform 0.25s ease;
    color: #1e40af;
  }

  .action-button:hover {
    background: #bfdbfe;
    border-color: #93c5fd;
    box-shadow: 0 2px 6px rgba(30, 64, 175, 0.15);
    transform: translateY(-1px);
  }

  .action-button:hover svg {
    transform: scale(1.1);
  }

  .action-button:active {
    background: #dbeafe;
    transform: translateY(0) scale(0.96);
    box-shadow: 0 1px 2px rgba(30, 64, 175, 0.05);
  }

  /* Hamburger Menu Button (Desktop + Mobile) */
  .hamburger-button {
    display: block; /* Visible on all screen sizes */
    padding: 0.5rem;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
    background: #dbeafe;
    color: #1e40af;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 1px 2px rgba(30, 64, 175, 0.05);
    position: relative;
    z-index: 10;
    height: 40px;
    width: 40px;
    transform: translateY(-12px) translateX(16px);
  }

  .hamburger-button:hover {
    background: #bfdbfe;
    border-color: #93c5fd;
  }

  .hamburger-button svg {
    width: 24px;
    height: 24px;
    display: block;
  }

  /* Desktop Action Buttons (Neu, Speichern, Laden) */
  .desktop-action-buttons {
    display: none; /* Hidden by default */
  }

  @media (min-width: 769px) {
    .desktop-action-buttons {
      display: flex;
      gap: 0.5rem;
      align-items: center;
    }
  }

  .desktop-action-button {
    display: block;
    padding: 0.5rem;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
    background: #dbeafe;
    color: #1e40af;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 1px 2px rgba(30, 64, 175, 0.05);
    position: relative;
    z-index: 10;
    height: 40px;
    width: 40px;
    transform: translateY(-12px);
  }

  .desktop-action-button:hover {
    background: #bfdbfe;
    border-color: #93c5fd;
  }

  .desktop-action-button svg {
    width: 24px;
    height: 24px;
    display: block;
  }

  /* Mobile Menu Dropdown */
  .mobile-menu-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 0.5rem;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    min-width: 180px;
    overflow: hidden;
    animation: slideDown 0.2s ease;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .mobile-menu-dropdown .action-button {
    width: 100%;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid transparent;
    background: white;
    justify-content: flex-start;
    padding: 0.1rem 1rem;
    box-shadow: none;
  }

  .mobile-menu-dropdown .action-button:last-child {
    border-bottom: none;
  }

  .mobile-menu-dropdown .action-button:hover {
    background: #f3f4f6;
    transform: none;
    box-shadow: none;
  }

  .mobile-menu-dropdown .action-button:hover svg {
    transform: scale(1.1);
  }

  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    z-index: 1000;
  }

  /* Header Media Query: Tablet & Mobile (<=768px)
     Note: at <=600 the following .header-content h1/p transform overrides
     from the 600 block (with !important) supersede these values. */
  @media (max-width: 768px) {
    .header-container {
      padding-top: 0 !important;
      margin-top: 0 !important;
    }

    .header-container::after {
      transform: translateY(-21px) !important;
    }

    .header-content h1 {
      font-size: 2rem !important;
      padding-top: 1rem !important;
      margin-left: 0px !important;
      transform: translateY(-15px) translateX(-18px);
    }

    .header-content p {
      font-size: 0.5625rem !important;
      padding: 0 !important;
      transform: translateY(-14px) translateX(67.5px);
    }

    .hamburger-button {
      transform: translateY(-24px) translateX(16px) !important;
    }

    .header-menu {
      transform: translate(-17px, -17px) !important;
    }
  }



  /* Desktop Styles (min-width 601px) */
  @media (min-width: 601px) {
    .header-container {
      padding-top: 0 !important;
      margin-top: 0 !important;
    }
  }

  /* Responsive: Adjustments for smaller screens */
  @media (max-width: 900px) and (min-width: 769px) {
    .header-actions {
      display: none !important; /* Hide regular buttons */
    }

    .header-content {
      padding-left: 13.875rem; /* Prevent overlap with hamburger menu */
    }

    .header-content h1 {
      margin-left: -366px !important;
      transform: translateY(-5px) !important;
    }

    .header-content p {
      margin-left: -342px !important;
      transform: translateY(-5px) !important;
    }
  }

  /* Mobile up to 600px (previously split into 492-600 and <=491, values identical) */
  @media (max-width: 600px) {
    .header-container {
      padding-top: 0 !important;
      margin-top: 0 !important;
    }

    .header-container::after {
      transform: translateY(-21px) !important;
    }

    .header-content h1 {
      font-size: 2rem !important;
      padding-top: 1rem !important;
      margin-left: 0 !important;
      transform: translateY(-15px) translateX(-18px) !important;
    }

    .header-content p {
      font-size: 0.5625rem !important;
      padding: 0 !important;
      transform: translateY(-14px) translateX(67.5px) !important;
    }

    .header-menu {
      transform: translate(-17px, -17px) !important;
    }
  }

  .toast {
    position: fixed;
    top: 2rem;
    right: 2rem;
    padding: 1.25rem 1.75rem;
    border-radius: 0.75rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    animation: slideInFromTop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    z-index: 2000;
    max-width: 420px;
    word-wrap: break-word;
    font-size: 1rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 1rem;
    min-height: 60px;
  }

  .toast.success {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border-left: 4px solid #06b6d4;
  }

  .toast.error {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    color: white;
    border-left: 4px solid #fbbf24;
    padding: 2.5rem 1.75rem;
    min-height: 110px;
  }

  .toast::before {
    content: '';
    display: flex;
    font-size: 1.5rem;
    font-weight: bold;
    min-width: 24px;
  }

  .toast.success::before {
    content: '✓';
  }

  .toast.error::before {
    content: '✕';
  }

  .toast.ai::before {
    content: '🤖';
  }

  .toast.warning::before {
    content: '⚠️';
    display: flex;
    font-size: 1.5rem;
    font-weight: bold;
    min-width: 24px;
  }

  .toast.warning {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    color: white;
    border-left: 4px solid #fbbf24;
    padding: 2.5rem 1.75rem;
    min-height: 110px;
  }

  .toast.ai {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    color: white;
    border-left: 4px solid #60a5fa;
    padding: 2.5rem 1.75rem;
    min-height: 110px;
  }

  @keyframes slideInFromTop {
    from {
      transform: translateY(-100px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slideOutToTop {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(-100px);
      opacity: 0;
    }
  }

  .toast.hide {
    animation: slideOutToTop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  }

  /* Calculation Name Display with Dropdown */
  .calculation-name-container {
    margin: 0 0 0.75rem 0;
    padding: 0;
    display: flex;
    align-items: center;
    position: relative;
    left: -2px;
  }

  .calculation-name-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
  }

  .calculation-name {
    margin: 0;
    font-size: 1.375rem;
    font-weight: 600;
    color: #3b82f6;
    white-space: nowrap;
    line-height: 1.5;
    max-width: 600px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .name-dropdown-btn {
    padding: 0.2rem 0.3rem;
    background: white;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0px;
    flex-shrink: 0;
    margin-top: -3px;
    width: auto;
    height: 25px;
  }

  .name-dropdown-btn .lightning-icon {
    width: 18px;
    height: 18px;
    color: #f59e0b;
    transition: transform 0.2s;
    flex-shrink: 0;
  }

  .name-dropdown-btn .chevron-icon {
    width: 10px;
    height: 10px;
    color: #6b7280;
    transition: transform 0.2s;
    flex-shrink: 0;
  }

  .name-dropdown-btn.active .chevron-icon {
    transform: rotate(180deg);
  }

  .name-dropdown-btn:hover {
    background: #f9fafb;
    border-color: #9ca3af;
  }

  .name-dropdown-btn:hover .lightning-icon {
    color: #d97706;
  }

  .name-dropdown-btn:hover .chevron-icon {
    color: #374151;
  }

  .name-dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
  }

  .name-dropdown-menu {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    min-width: 200px;
    background: white;
    border-radius: 6px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    padding: 0.5rem 0;
    z-index: 1000;
  }

  .dropdown-item {
    width: 100%;
    padding: 0.1rem 1rem;
    border: none;
    background: white;
    color: #1e40af;
    font-size: 0.8rem;
    font-weight: 500;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  .dropdown-item svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    transition: transform 0.25s ease;
  }

  .dropdown-item:hover {
    background: #f3f4f6;
  }

  .dropdown-item:hover svg {
    transform: scale(1.1);
  }

  .dropdown-item.danger {
    color: #dc2626;
  }

  .dropdown-item.danger:hover {
    background: #fef2f2;
  }

  .dropdown-divider {
    height: 1px;
    background: #e5e7eb;
    margin: 0.5rem 0;
  }

  /* Mobile Adjustments */
  @media (max-width: 768px) {
    .calculation-name-container {
      margin: 0 1rem 1rem 1rem;
    }

    .calculation-name {
      font-size: 1rem;
      max-width: calc(100vw - 100px);
    }

    .name-dropdown-menu {
      right: auto;
      left: 0;
      width: 100%;
    }
  }

</style>

<main [class.help-hidden]="!helpSidebarVisible()">
  <!-- Header Section with User Menu -->
  <div class="header-container">
    <!-- Action Menu -->
    @if (isLoggedIn()) {
      <div style="position: relative;">
        <button type="button" class="hamburger-button" (click)="toggleActionMenu()" title="Menü">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>

        @if (actionMenuOpen()) {
          <div class="mobile-menu-overlay" (click)="closeActionMenu()"></div>
          <div class="mobile-menu-dropdown">
            <!-- Neu -->
            <button type="button" class="action-button" title="Neue Berechnung" (click)="newCalculation(); closeActionMenu()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
              Neu
            </button>
            
            <!-- Speichern -->
            <button type="button" class="action-button" title="Berechnung speichern" (click)="openSaveDialog(); closeActionMenu()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                <polyline points="17 21 17 13 7 13 7 21"></polyline>
                <polyline points="7 3 7 8 15 8"></polyline>
              </svg>
              Speichern
            </button>
            
            <!-- Laden -->
            <button type="button" class="action-button" title="Berechnung laden" (click)="openLoadDialog(); closeActionMenu()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              Laden
            </button>
            
            <!-- Divider -->
            <div style="height: 1px; background: #e5e7eb; margin: 0.25rem 0;"></div>
            
            <!-- Berechnung (wenn Berechnung geladen) -->
            @if (currentCalculationId()) {
              <div style="padding: 0.1rem 0;">
                <div style="font-size: 0.75rem; font-weight: 500; color: #6b7280; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.1rem; padding: 0 1rem;">Berechnung</div>
                <button type="button" class="action-button" title="Berechnung umbenennen" (click)="openRenameDialog(); closeActionMenu()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 20h9"></path>
                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19H4v-3L16.5 3.5z"></path>
                  </svg>
                  Umbenennen
                </button>
                <button type="button" class="action-button" title="Berechnung duplizieren" (click)="openDuplicateDialog(); closeActionMenu()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                  Duplizieren
                </button>
                <button type="button" class="action-button" style="color: #dc2626;" title="Berechnung löschen" (click)="openDeleteDialog(); closeActionMenu()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                  Löschen
                </button>
              </div>
            }
            
            <!-- Divider -->
            <div style="height: 1px; background: #e5e7eb; margin: 0.25rem 0;"></div>
            
            <!-- Exportieren -->
            <div style="padding: 0.1rem 0;">
              <div style="font-size: 0.75rem; font-weight: 500; color: #6b7280; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.1rem; padding: 0 1rem;">Exportieren</div>
              <button type="button" class="action-button" title="Kalkulation als PDF exportieren" (click)="openExportDialog(); closeActionMenu()">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <circle cx="12" cy="16" r="1"></circle>
                  <path d="M9 15h6M9 17h6"></path>
                </svg>
                Kalkulations-Export
              </button>
              <button type="button" class="action-button" title="Mehrere Kalkulationen exportieren & vergleichen" (click)="openComparisonExportDialog(); closeActionMenu()">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M8 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h2"></path>
                  <path d="M16 2h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2"></path>
                  <polyline points="6 9 4 11 6 13"></polyline>
                  <polyline points="18 9 20 11 18 13"></polyline>
                  <line x1="4" y1="11" x2="20" y2="11"></line>
                </svg>
                Vergleichs-Export
              </button>
            </div>
          </div>
        }
      </div>

      <!-- Desktop Action Buttons (nur sichtbar auf Desktop > 768px) -->
      <div class="desktop-action-buttons">
        <!-- Neu Button -->
        <button type="button" class="desktop-action-button" title="Neue Berechnung" (click)="newCalculation()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
          </svg>
        </button>
        
        <!-- Speichern Button -->
        <button type="button" class="desktop-action-button" title="Berechnung speichern" (click)="openSaveDialog()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
            <polyline points="17 21 17 13 7 13 7 21"></polyline>
            <polyline points="7 3 7 8 15 8"></polyline>
          </svg>
        </button>
        
        <!-- Laden Button -->
        <button type="button" class="desktop-action-button" title="Berechnung laden" (click)="openLoadDialog()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
        </button>
      </div>
    }
    
    <div class="header-content">
      <h1 (click)="goHome()" style="cursor: pointer;">{{ title() }}</h1>
      <p style="font-size: 0.875rem; text-align: center; padding-left: 27px;">
        <span style="color: oklch(51% 0.28 263.83);">PRO</span>PERTY <span style="color: oklch(51% 0.28 263.83);">TYCO</span>ON
      </p>
    </div>
    <div class="header-menu">
      <!-- Help Toggle Button -->
      <button 
        type="button" 
        class="help-toggle-icon" 
        (click)="toggleHelpSidebar()"
        [title]="helpSidebarVisible() ? 'Hilfe ausblenden' : 'Hilfe einblenden'">
        @if (helpSidebarVisible()) {
          <!-- Ausgeschaltete realistische Glühbirne (Hilfe ist sichtbar, klick zum Ausblenden) -->
          <svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <!-- Glühbirne ohne Füllung -->
            <path d="M12 2a6 6 0 0 1 6 6c0 2.5-1.5 4-2 5.5-.5 1.5-.5 2.5-.5 3.5h-7c0-1 0-2-.5-3.5-.5-1.5-2-3-2-5.5a6 6 0 0 1 6-6z" 
                  fill="none" stroke="oklch(51.01% 0.274 263.83)" stroke-width="2"></path>
            <!-- Glühfaden im Inneren (ausgegraut) -->
            <path d="M10.5 6c0 0 1-1 1.5-1s1.5 1 1.5 1" stroke="oklch(51.01% 0.274 263.83)" stroke-width="1.5" fill="none"></path>
            <line x1="12" y1="5" x2="12" y2="8" stroke="oklch(51.01% 0.274 263.83)" stroke-width="1.5"></line>
            <!-- Gewinde/Sockel -->
            <line x1="9" y1="17" x2="15" y2="17" stroke="oklch(51.01% 0.274 263.83)" stroke-width="2"></line>
            <line x1="9.5" y1="19" x2="14.5" y2="19" stroke="oklch(51.01% 0.274 263.83)" stroke-width="2"></line>
            <line x1="10" y1="21" x2="14" y2="21" stroke="oklch(51.01% 0.274 263.83)" stroke-width="2"></line>
          </svg>
        } @else {
          <!-- Leuchtende realistische Glühbirne mit gelbem Licht (Hilfe ist versteckt, klick zum Einblenden) -->
          <svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <!-- Gelbe leuchtende Glühbirne -->
            <path d="M12 2a6 6 0 0 1 6 6c0 2.5-1.5 4-2 5.5-.5 1.5-.5 2.5-.5 3.5h-7c0-1 0-2-.5-3.5-.5-1.5-2-3-2-5.5a6 6 0 0 1 6-6z" 
                  fill="#fbbf24" stroke="#f59e0b" stroke-width="2"></path>
            <!-- Glühfaden im Inneren -->
            <path d="M10.5 6c0 0 1-1 1.5-1s1.5 1 1.5 1" stroke="#f59e0b" stroke-width="1.5" fill="none"></path>
            <line x1="12" y1="5" x2="12" y2="8" stroke="#f59e0b" stroke-width="1.5"></line>
            <!-- Gewinde/Sockel -->
            <line x1="9" y1="17" x2="15" y2="17" stroke="oklch(51.01% 0.274 263.83)" stroke-width="2"></line>
            <line x1="9.5" y1="19" x2="14.5" y2="19" stroke="oklch(51.01% 0.274 263.83)" stroke-width="2"></line>
            <line x1="10" y1="21" x2="14" y2="21" stroke="oklch(51.01% 0.274 263.83)" stroke-width="2"></line>
            <!-- Gelbe Lichtstrahlen -->
            <line x1="12" y1="1" x2="12" y2="2.5" stroke="#fbbf24" stroke-width="2.5"></line>
            <line x1="4.22" y1="4.22" x2="5.5" y2="5.5" stroke="#fbbf24" stroke-width="2.5"></line>
            <line x1="1" y1="12" x2="2.5" y2="12" stroke="#fbbf24" stroke-width="2.5"></line>
            <line x1="4.22" y1="19.78" x2="5.5" y2="18.5" stroke="#fbbf24" stroke-width="2.5"></line>
            <line x1="19.78" y1="4.22" x2="18.5" y2="5.5" stroke="#fbbf24" stroke-width="2.5"></line>
            <line x1="22" y1="12" x2="20.5" y2="12" stroke="#fbbf24" stroke-width="2.5"></line>
            <line x1="19.78" y1="19.78" x2="18.5" y2="18.5" stroke="#fbbf24" stroke-width="2.5"></line>
          </svg>
        }
      </button>
      <app-user-menu></app-user-menu>
    </div>
  </div>

  <div class="app-scroll">

  <!-- Expiring Subscription Banner -->
  <app-expiring-subscription-banner></app-expiring-subscription-banner>

  <!-- Calculation Name Display with Dropdown Menu -->
  @if (isLoggedIn() && currentCalculationName()) {
    <div class="calculation-name-container">
      <div class="calculation-name-wrapper">
        <h3 class="calculation-name" [title]="currentCalculationName()">{{ currentCalculationName() }}</h3>
        <button 
          type="button" 
          class="name-dropdown-btn" 
          (click)="toggleNameDropdown()"
          [class.active]="nameDropdownOpen()"
          title="Optionen">
          <!-- Blitz Icon -->
          <svg class="lightning-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
          </svg>
          <!-- Pfeil Icon -->
          <svg class="chevron-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        
        @if (nameDropdownOpen()) {
          <div class="name-dropdown-overlay" (click)="closeNameDropdown()"></div>
          <div class="name-dropdown-menu">
            <button type="button" class="dropdown-item" (click)="openRenameDialog()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 20h9"></path>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19H4v-3L16.5 3.5z"></path>
              </svg>
              Umbenennen
            </button>
            <button type="button" class="dropdown-item" (click)="openDuplicateDialog()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
              Duplizieren
            </button>
            <div class="dropdown-divider"></div>
            <button type="button" class="dropdown-item danger" (click)="openDeleteDialog()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
              Löschen
            </button>
          </div>
        }
      </div>
    </div>
  }

  <!-- Address Section - Form + Help in same wrapper -->
  <div class="section-wrapper">
    <div class="calculator-container">
      <button type="button" class="section-title" (click)="toggleAddressData()" [class.collapsed]="!addressDataExpanded()">Adressdaten</button>
      
      @if (addressDataExpanded()) {
        <form autocomplete="off">
          <!-- All address fields in 4-column grid layout -->
          <div class="address-grid">
          <div class="form-group">
            <label for="country">Land <span class="required">*</span>
              <button type="button" class="info-btn" (click)="showTooltip('country', $event)" aria-label="Hilfe zu Land">?</button>
            </label>
            <div class="autocomplete-wrapper">
              <input
                id="country"
                type="text"
                [value]="country()"
                (input)="updateCountry($event)"
                (focus)="showCountrySuggestions.set(countrySuggestions().length > 0)"
                (blur)="hideCountrySuggestions()"
                placeholder="z.B. Deutschland"
                aria-label="Land eingeben"
                autocomplete="off"
              />
              
              @if (isLoadingCountries()) {
                <div class="suggestions-loading">
                  <span class="spinner"></span> Suche lädt...
                </div>
              }
              
              @if (showCountrySuggestions() && countrySuggestions().length > 0) {
                <ul class="suggestions-list" role="listbox">
                  @for (suggestion of countrySuggestions(); track suggestion.display_name) {
                    <li 
                      role="option"
                      class="suggestion-item"
                      (click)="selectCountry(suggestion)"
                    >
                      <strong>{{ suggestion.address?.country || suggestion.display_name }}</strong>
                    </li>
                  }
                </ul>
              }
            </div>
          </div>

          <!-- City (disabled if no country selected) -->
          <div class="form-group">
            <label for="city">Stadt <span class="required">*</span>
              <button type="button" class="info-btn" (click)="showTooltip('city', $event)" aria-label="Hilfe zu Stadt">?</button>
            </label>
            <div class="autocomplete-wrapper">
              <input
                id="city"
                type="text"
                [value]="city()"
                (input)="updateCity($event)"
                (focus)="showCitySuggestions.set(citySuggestions().length > 0)"
                (blur)="hideCitySuggestions()"
                [disabled]="!country()"
                placeholder="z.B. Berlin"
                aria-label="Stadt eingeben"
                autocomplete="off"
                />
                
                @if (isLoadingCities()) {
                  <div class="suggestions-loading">
                    <span class="spinner"></span> Suche lädt...
                  </div>
                }
                
                @if (showCitySuggestions() && citySuggestions().length > 0) {
                  <ul class="suggestions-list" role="listbox">
                    @for (suggestion of citySuggestions(); track suggestion.display_name) {
                      <li 
                        role="option"
                        class="suggestion-item"
                        (click)="selectCity(suggestion)"
                      >
                        <strong>{{ suggestion.address?.city || suggestion.display_name.split(',')[0] }}</strong>
                        @if (suggestion.address?.postcode) {
                          <span class="suggestion-detail">{{ suggestion.address?.postcode }}</span>
                        }
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>

          <div class="form-group">
            <label for="address">Straße und Hausnummer <span class="required">*</span>
              <button type="button" class="info-btn" (click)="showTooltip('address', $event)" aria-label="Hilfe zu Straße">?</button>
            </label>
            <div class="autocomplete-wrapper">
              <input
                id="address"
                type="text"
                [value]="address()"
                [disabled]="!country() || !city()"
                (input)="updateAddress($event)"
                (focus)="showAddressSuggestions.set(addressSuggestions().length > 0)"
                (blur)="hideAddressSuggestions()"
                placeholder="z.B. Hauptstraße 42"
                aria-label="Anschrift eingeben"
                autocomplete="off"
              />
              
              @if (isLoadingAddresses()) {
                <div class="suggestions-loading">
                  <span class="spinner"></span> Suche lädt...
                </div>
              }
              
              @if (showAddressSuggestions() && addressSuggestions().length > 0) {
                <ul class="suggestions-list" role="listbox">
                  @for (suggestion of addressSuggestions(); track suggestion.display_name) {
                    <li 
                      role="option"
                      class="suggestion-item"
                      (click)="selectAddress(suggestion)"
                    >
                      <strong>{{ suggestion.address?.road || suggestion.display_name.split(',')[0] }}</strong>
                      @if (suggestion.address?.postcode) {
                        <span class="suggestion-detail">{{ suggestion.address?.postcode }}</span>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          </div>

          <!-- Postal Code (read-only, auto-filled) -->
          <div class="form-group">
            <label for="postalCode">Postleitzahl <span class="required">*</span>
              <button type="button" class="info-btn" (click)="showTooltip('postalCode', $event)" aria-label="Hilfe zu Postleitzahl">?</button>
            </label>
            <input
              id="postalCode"
              type="text"
              [value]="postalCodeDisplay()"
              (input)="updatePostalCode($event)"
              placeholder="z.B. 10115"
              aria-label="Postleitzahl"
            />
          </div>
        </div>
      </form>
    }
    </div>
    <!-- Adressdaten Help Section -->
    <div class="help-section" [class.collapsed]="!addressDataExpanded()">
      <h3 class="help-section-title">Adressdaten</h3>
      <div class="help-content">
        <p><strong>Land:</strong> Wählen Sie das Land, in dem sich die Immobilie befindet. Dies ist wichtig für die Berechnung von Steuersätzen.</p>
        <p><strong>Stadt *:</strong> Der Ort beeinflusst die Grunderwerbsteuer. Unterschiedliche Bundesländer und Kommunen haben unterschiedliche Sätze. Anhand der Stadt wird automatisch die Grunderwerbsteuer ermittelt.</p>
        <p><strong>Straße:</strong> Vollständige Straßenadresse zur Identifikation der Immobilie. Anhand der Adresse werden die erwarteten Mieteinnahmen ermittelt.</p>
        <p><strong>Postleitzahl:</strong> Postleitzahl des Objekts. Wird automatisch ausgefüllt basierend auf der gewählten Adresse und kann manuell angepasst werden.</p>
      </div>
    </div>
  </div>

  <!-- Kaufkosten Section - Form + Help in same wrapper -->
  <div class="section-wrapper">
    <div class="calculator-container">
    <button type="button" class="section-title" (click)="togglePurchaseCosts()" [class.collapsed]="!purchaseCostsExpanded()">Kaufkosten</button>
    
    @if (purchaseCostsExpanded()) {
      <div class="costs-grid">
        <div class="form-group">
          <label for="purchasePrice">
            Kaufpreis (€) <span class="required">*</span>
            <button type="button" class="info-btn" (click)="showTooltip('purchasePrice', $event)" aria-label="Hilfe zu Kaufpreis">?</button>
          </label>
          <input
            id="purchasePrice"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [(ngModel)]="purchasePriceInput"
            (keypress)="onRentalPriceKeyPress($event)"
            (input)="updatePurchasePrice($event)"
            (focus)="onCurrencyFocus($event)"
            (blur)="onCurrencyBlur($event)"
            placeholder="z.B. 250.000"
            required
            aria-label="Kaufpreis (erforderlich)"
          />
        </div>

        <div class="form-group">
          <label for="agentCostsPercentage">
            Makler (%)
            <button type="button" class="info-btn" (click)="showTooltip('agentCostsPercentage', $event)" aria-label="Hilfe zu Maklerkosten in Prozent">?</button>
          </label>
          <input
            id="agentCostsPercentage"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [(ngModel)]="agentCostsPercentageInput"
            (keypress)="onDecimalKeyPress($event)"
            (input)="updateAgentCostsPercentage($event)"
            placeholder="z.B. 3,57"
            aria-label="Maklerkosten in Prozent (optional)"
          />
        </div>

        <div class="form-group">
          <label for="agentCosts">
            Makler (€)
            <button type="button" class="info-btn" (click)="showTooltip('agentCosts', $event)" aria-label="Hilfe zu Maklerkosten">?</button>
          </label>
          <input
            id="agentCosts"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [value]="agentCostsInput()"
            (keypress)="onDecimalKeyPress($event)"
            (input)="updateAgentCosts($event)"
            (focus)="onCurrencyFocus($event)"
            (blur)="onAgentCostsBlur($event)"
            placeholder="z.B. 7.500"
            aria-label="Maklerkosten (optional)"
          />
        </div>

        <div class="form-group">
          <label for="acquisitionTaxPercentage">
            Grunderwerbsteuer (%)
            <button type="button" class="info-btn" (click)="showTooltip('acquisitionTaxPercentage', $event)" aria-label="Hilfe zu Grunderwerbsteuer in Prozent">?</button>
          </label>
          <input
            id="acquisitionTaxPercentage"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [(ngModel)]="acquisitionTaxPercentageInput"
            (keypress)="onRentalPriceKeyPress($event)"
            (input)="updateAcquisitionTaxPercentage($event)"
            placeholder="z.B. 5,0"
            aria-label="Grunderwerbsteuer in Prozent (optional)"
          />
        </div>

        <div class="form-group">
          <label for="acquisitionTax">
            Grunderwerbsteuer (€)
            <button type="button" class="info-btn" (click)="showTooltip('acquisitionTax', $event)" aria-label="Hilfe zu Grunderwerbsteuer">?</button>
          </label>
          <input
            id="acquisitionTax"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [value]="acquisitionTaxInput()"
            (keypress)="onDecimalKeyPress($event)"
            (input)="updateAcquisitionTax($event)"
            (focus)="onCurrencyFocus($event)"
            (blur)="onAcquisitionTaxBlur($event)"
            placeholder="z.B. 15.000"
            aria-label="Grunderwerbsteuer (optional)"
          />
        </div>
      </div>

      <div class="price-fields-grid">
        <div class="form-group">
          <label for="notaryCostsPercentage">
            Notarkosten in %
            <button type="button" class="info-btn" (click)="showTooltip('notaryCostsPercentage', $event)" aria-label="Hilfe zu Notarkosten in Prozent">?</button>
          </label>
          <input
            id="notaryCostsPercentage"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [(ngModel)]="notaryCostsPercentageInput"
            (keypress)="onRentalPriceKeyPress($event)"
            (input)="updateNotaryCostsPercentage($event)"
            placeholder="z.B. 1,5"
            aria-label="Notarkosten in Prozent (optional)"
          />
        </div>

        <div class="form-group">
          <label for="notaryCosts">
            Notarkosten (€)
            <button type="button" class="info-btn" (click)="showTooltip('notaryCosts', $event)" aria-label="Hilfe zu Notarkosten">?</button>
          </label>
          <input
            id="notaryCosts"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [value]="notaryCostsInput()"
            (keypress)="onDecimalKeyPress($event)"
            (input)="updateNotaryCosts($event)"
            (focus)="onCurrencyFocus($event)"
            (blur)="onNotaryCostsBlur($event)"
            placeholder="z.B. 3.750"
            aria-label="Notarkosten (optional)"
          />
        </div>

        <div class="form-group">
          <label for="landRegistryCostsPercentage">
            Grundbuchamtkosten (%)
            <button type="button" class="info-btn" (click)="showTooltip('landRegistryCostsPercentage', $event)" aria-label="Hilfe zu Grundbuchamtkosten in Prozent">?</button>
          </label>
          <input
            id="landRegistryCostsPercentage"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [(ngModel)]="landRegistryCostsPercentageInput"
            (keypress)="onRentalPriceKeyPress($event)"
            (input)="updateLandRegistryCostsPercentage($event)"
            placeholder="z.B. 0,5"
            aria-label="Grundbuchamtkosten in Prozent (optional)"
          />
        </div>

        <div class="form-group">
          <label for="landRegistryCosts">
            Grundbuchamtkosten (€)
            <button type="button" class="info-btn" (click)="showTooltip('landRegistryCosts', $event)" aria-label="Hilfe zu Grundbuchamt">?</button>
          </label>
          <input
            id="landRegistryCosts"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [value]="landRegistryCostsInput()"
            (keypress)="onDecimalKeyPress($event)"
            (input)="updateLandRegistryCosts($event)"
            (focus)="onCurrencyFocus($event)"
            (blur)="onLandRegistryCostsBlur($event)"
            placeholder="z.B. 1.250"
            aria-label="Grundbuchamtkosten (optional)"
          />
        </div>

        <div class="form-group">
          <label for="otherCosts">
            Sonstige Kosten (€)
          </label>
          <input
            id="otherCosts"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [value]="otherCostsInput()"
            (keypress)="onRentalPriceKeyPress($event)"
            (input)="updateOtherCosts($event)"
            (focus)="onCurrencyFocus($event)"
            (blur)="onOtherCostsBlur($event)"
            placeholder="z.B. 2.000"
            aria-label="Sonstige Kosten (optional)"
          />
        </div>
      </div>

      <div class="price-fields-grid">
        <div class="form-group">
          <label for="totalBuyingCosts">
            Gesamt-Kaufkosten (€)
          </label>
          <input
            id="totalBuyingCosts"
            type="text"
            style="text-align: right;"
            [value]="totalBuyingCostsDisplay()"
            readonly
            aria-label="Gesamt-Kaufkosten (schreibgeschützt)"
            class="total-income-field"
          />
        </div>

        <div class="form-group">
          <label for="eigenkapital">
            Eigenkapital (€)
            <button type="button" class="info-btn" (click)="showTooltip('eigenkapital', $event)" aria-label="Hilfe zu Eigenkapital">?</button>
          </label>
          <input
            id="eigenkapital"
            type="text"
            style="text-align: right;"
            pattern="[0-9]*([,][0-9]{1,2})?"
            [value]="eigenkapitalInput()"
            (keypress)="onRentalPriceKeyPress($event)"
            (input)="updateEigenkapital($event)"
            (focus)="onCurrencyFocus($event)"
            (blur)="onEigenkapitalBlur($event)"
            placeholder="z.B. 50.000"
            aria-label="Eigenkapital (optional)"
          />
        </div>

        <div class="form-group">
          <label for="kreditbedarf">
            Kreditbedarf (€)
            <button type="button" class="info-btn" (click)="showTooltip('kreditbedarf', $event)" aria-label="Hilfe zu Kreditbedarf">?</button>
          </label>
          <input
            id="kreditbedarf"
            type="text"
            style="text-align: right;"
            [value]="kreditbedarfDisplay()"
            readonly
            aria-label="Kreditbedarf (schreibgeschützt)"
            class="credit-needed-field"
          />
        </div>
      </div>
    }
    </div>
    <!-- Kaufkosten Help Section -->
    <div class="help-section" [class.collapsed]="!purchaseCostsExpanded()">
      <h3 class="help-section-title">Kaufkosten</h3>
      <div class="help-content">
        <p><strong>Kaufpreis:</strong> Die Gesamtkaufpreissumme der Immobilie.</p>
        <p><strong>Maklerkosten:</strong> Üblicherweise 3-8% des Kaufpreises. Werden oft zwischen Käufer und Verkäufer aufgeteilt.</p>
        <p><strong>Notarkosten:</strong> Ca. 1-1,5% des Kaufpreises. Sind in Deutschland gesetzlich festgelegt.</p>
        <p><strong>Grundbuchamtkosten:</strong> Ca. 0,5% des Kaufpreises. Entstehen durch die Eintragung ins Grundbuch.</p>
        <p><strong>Grunderwerbsteuer:</strong> Regional unterschiedlich. Wird automatisch basierend auf der Stadt berechnet.</p>
        <p><strong>Eigenkapital:</strong> Der Betrag, den Sie selbst einzahlen. Höheres Eigenkapital = niedrigere Kredite und bessere Konditionen.</p>
        <p><strong>Kreditbedarf (€):</strong> Der Kaufpreis abzüglich des Eigenkapitals. Der Betrag, den Sie finanzieren müssen.</p>
      </div>
    </div>
  </div>

  <!-- Section 4: Objekt-Einnahmen - Form + Help in same wrapper -->
  <div class="section-wrapper">
    <div class="calculator-container">
      <button type="button" class="section-title" (click)="toggleObjectIncome()" [class.collapsed]="!objectIncomeExpanded()">Objekt-Einnahmen</button>
      @if (objectIncomeExpanded()) {
        <div class="objekt-einnahmen-grid">
          <div class="form-group">
            <label for="objectSize">Objekt-Größe in m²
              <button type="button" class="info-btn" (click)="showTooltip('objectSize', $event)" aria-label="Hilfe zu Objekt-Größe">?</button>
            </label>
            <input id="objectSize" type="text" [value]="objectSizeInput()" (blur)="onObjectSizeBlur($event)" (focus)="onCurrencyFocus($event)" (keypress)="onDecimalKeyPress($event)" (input)="updateObjectSize($event)" placeholder="z.B. 100,50" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Objekt-Größe in Quadratmetern" style="text-align: right;" />
          </div>

          <div class="form-group">
            <label for="constructionYear">Baujahr
              <button type="button" class="info-btn" (click)="showTooltip('constructionYear', $event)" aria-label="Hilfe zu Baujahr">?</button>
            </label>
            <input id="constructionYear" type="text" maxlength="4" pattern="[0-9]{4}" inputmode="numeric" [value]="constructionYearInput()" (input)="updateConstructionYear($event)" (blur)="onConstructionYearBlur($event)" placeholder="z.B. 1985" aria-label="Baujahr des Gebäudes" style="text-align: right;" />
          </div>

          <div class="form-group">
            <label for="kaufpreisProQm">Kaufpreis / m² (€)</label>
            <input id="kaufpreisProQm" type="text" style="text-align: right;" [value]="kaufpreisProQuadratmeterDisplay()" readonly aria-label="Kaufpreis pro Quadratmeter (schreibgeschützt)" class="price-per-sqm-field" />
          </div>

          <div class="form-group">
            <label for="rentalPrice">Nettokaltmiete / m² (€)
              <button type="button" class="info-btn" (click)="showTooltip('rentalPrice', $event)" aria-label="Hilfe zu Mietpreis">?</button>
            </label>
            <div class="rental-price-wrapper">
              <input id="rentalPrice" type="text" style="text-align: right;" [value]="rentalPriceInput()" (keypress)="onRentalPriceKeyPress($event)" (input)="updateRentalPrice($event)" (focus)="onRentalPriceFocus($event)" (blur)="onRentalPriceBlur($event)" placeholder="z.B. 20" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Mietpreis pro Quadratmeter (optional)" />
              <button type="button" class="ai-button" (click)="askAiRent()" [disabled]="isLoadingAi()" title="KI schätzt Nettokaltmiete" aria-label="KI schätzt Nettokaltmiete pro Quadratmeter">
                @if (isLoadingAi()) {
                  <span>⏳</span>
                } @else {
                  <span>🤖</span>
                }
              </button>
              @if (!isLoadingRentalPrice() && rentalPriceError()) {
                <div class="price-error">⚠️ {{ rentalPriceError() }}</div>
              }
            </div>
          </div>

          <div class="form-group">
            <label for="monthlyRentalPrice">Monatliche Nettokaltmiete / m² (€)
              <button type="button" class="info-btn" (click)="showTooltip('monthlyRentalPrice', $event)" aria-label="Hilfe zu Monatliche Mieteinnahmen">?</button>
            </label>
            <input id="monthlyRentalPrice" type="text" style="text-align: right;" [value]="monthlyRentalPriceInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateMonthlyRentalPrice($event)" (focus)="onMonthlyRentalPriceFocus($event)" (blur)="onMonthlyRentalPriceBlur($event)" placeholder="Eingabe/Berechnung" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Monatlicher Mietpreis pro Quadratmeter (optional)" />
          </div>

          <div class="form-group">
            <label for="additionalMonthlyIncome">Weitere monatliche Einnahmen (€)
              <button type="button" class="info-btn" (click)="showTooltip('additionalMonthlyIncome', $event)" aria-label="Hilfe zu Weitere Einnahmen">?</button>
            </label>
            <input id="additionalMonthlyIncome" type="text" style="text-align: right;" [value]="additionalMonthlyIncomeInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateAdditionalMonthlyIncome($event)" (focus)="onAdditionalMonthlyIncomeFocus($event)" (blur)="onAdditionalMonthlyIncomeBlur($event)" placeholder="Eingabe/Berechnung" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Weitere monatliche Objekt-Einnahmen (optional)" />
          </div>

          <div class="form-group">
            <label for="totalMonthlyIncome">Monatliche Gesamteinnahmen (€)</label>
            <input id="totalMonthlyIncome" type="text" style="text-align: right;" [value]="totalMonthlyIncomeDisplay()" readonly aria-label="Monatliche Gesamteinnahmen (schreibgeschützt)" class="total-income-field" />
          </div>

          <div class="form-group">
            <label for="yearlyRentalPrice">Jährliche Nettokaltmiete / m² (€)
              <button type="button" class="info-btn" (click)="showTooltip('yearlyRentalPrice', $event)" aria-label="Hilfe zu Jährliche Mieteinnahmen">?</button>
            </label>
            <input id="yearlyRentalPrice" type="text" style="text-align: right;" [value]="yearlyRentalPriceInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateYearlyRentalPrice($event)" (focus)="onYearlyRentalPriceFocus($event)" (blur)="onYearlyRentalPriceBlur($event)" placeholder="Eingabe/Berechnung" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Jährlicher Mietpreis pro Quadratmeter (optional)" />
          </div>

          <div class="form-group">
            <label for="additionalYearlyIncome">Weitere jährliche Einnahmen (€)</label>
            <input id="additionalYearlyIncome" type="text" style="text-align: right;" [value]="additionalYearlyIncomeInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateAdditionalYearlyIncome($event)" (focus)="onAdditionalYearlyIncomeFocus($event)" (blur)="onAdditionalYearlyIncomeBlur($event)" placeholder="Eingabe/Berechnung" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Weitere jährliche Objekt-Einnahmen (optional)" />
          </div>

          <div class="form-group">
            <label for="totalYearlyIncome">Jährliche Gesamteinnahmen (€)</label>
            <input id="totalYearlyIncome" type="text" style="text-align: right;" [value]="totalYearlyIncomeDisplay()" readonly aria-label="Jährliche Gesamteinnahmen (schreibgeschützt)" class="total-income-field" />
          </div>

          <div class="form-group">
            <label for="xfachVonKaufpreis">x-fach von Kaufpreis (Jahre)</label>
            <input id="xfachVonKaufpreis" type="text" style="text-align: right;" [value]="xfachVonKaufpreisDisplay()" readonly aria-label="x-fach von Kaufpreis in Jahren (schreibgeschützt)" class="price-per-sqm-field" />
          </div>

          <div class="form-group">
            <label for="xfachVonGesamtKaufkosten">x-fach von Gesamt-Kaufkosten (Jahre)</label>
            <input id="xfachVonGesamtKaufkosten" type="text" style="text-align: right;" [value]="xfachVonGesamtKaufkostenDisplay()" readonly aria-label="x-fach von Gesamt-Kaufkosten in Jahren (schreibgeschützt)" class="price-per-sqm-field" />
          </div>
        </div>
      }
    </div>
    <!-- Objekt-Einnahmen Help Section -->
    <div class="help-section" [class.collapsed]="!objectIncomeExpanded()">
      <h3 class="help-section-title">Objekt-Einnahmen</h3>
      <div class="help-content">
        <p><strong>Baujahr:</strong> Baujahr des Gebäudes (optional). Relevant für die Mietpreisbremse (§ 556d BGB) – Neubauten ab Baujahr 2014 sind ausgenommen (§ 556f BGB). Zusätzlich beeinflusst das Alter die Wertsteigerungsprognose (Neubau, Bestand, Altbau, Denkmalschutz). Wenn unbekannt, einfach leer lassen – die KI kalkuliert dann konservativ.</p>
        <p><strong>Mieteinnahmen monatlich:</strong> Monatliche Mieteinnahmen aus der Immobilie.</p>
        <p><strong>Mieteinnahmen jährlich:</strong> Annualisierte Mieteinnahmen (monatlich × 12).</p>
        <p><strong>Weitere Einnahmen monatlich:</strong> Zusätzliche monatliche Einnahmen wie Parkplätze, Nebenräume, etc.</p>
        <p><strong>Weitere Einnahmen jährlich:</strong> Annualisierte zusätzliche Einnahmen.</p>
        <p><strong>🤖 Nettokaltmiete / m² (€):</strong> Der KI-Button analysiert Ihre Adressdaten (Land, Stadt, Postleitzahl, Straße, Objektgröße) und schätzt einen marktgerechten Mietpreis. Das Ergebnis wird direkt ins Eingabefeld übernommen und kann jederzeit manuell angepasst werden.</p>
        <p><strong>x-fach von Kaufpreis (Jahre):</strong> Wie viele Jahre es dauern würde, bis die jährlichen Mieteinnahmen den Kaufpreis amortisieren. Berechnung: Kaufpreis ÷ Jährliche Mieteinnahmen. Niedrigere Werte sind besser. Beachte: Dies berücksichtigt keine Nebenkosten oder laufenden Ausgaben.</p>
        <p><strong>x-fach von Gesamt-Kaufkosten (Jahre):</strong> Wie "x-fach von Kaufpreis", berücksichtigt aber zusätzlich alle Kaufnebenkosten (Makler, Grunderwerbsteuer, Notar, Grundbuchamtkosten, etc.). Realistischere Einschätzung der Amortisationsdauer.</p>
      </div>
    </div>
  </div>

  <!-- Section 5: Finanzierungs-Kosten - Form + Help in same wrapper -->
  <div class="section-wrapper">
    <div class="calculator-container">
      <button type="button" class="section-title" (click)="toggleFinancing()" [class.collapsed]="!financingExpanded()">Finanzierungs-Kosten</button>
      @if (financingExpanded()) {
        <div>
          @if (error()) {
            <div class="error" role="alert">{{ error() }}</div>
          }

          <!-- Financing grid -->
          <div class="financing-grid">
            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="kreditbedarfFinancing">Kreditbedarf (€)
                <button type="button" class="info-btn" (click)="showTooltip('kreditbedarf', $event)" aria-label="Hilfe zu Kreditbedarf">?</button>
              </label>
              <input id="kreditbedarfFinancing" type="text" [value]="kreditbedarfDisplay()" readonly aria-label="Kreditbedarf in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="interestRate">Jahreszins effektiv (%)
                <button type="button" class="info-btn" (click)="showTooltip('interestRate', $event)" aria-label="Hilfe zu Jahreszins">?</button>
              </label>
              <input id="interestRate" type="text" [value]="interestRateInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateInterestRate($event)" placeholder="z.B. 3,8" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Jahreszins effektiv in Prozent" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="amortizationRate">Anfängliche Tilgung (%)
                <button type="button" class="info-btn" (click)="showTooltip('amortizationRate', $event)" aria-label="Hilfe zu Tilgung">?</button>
              </label>
              <input id="amortizationRate" type="text" [value]="amortizationRateDisplay()" (keypress)="onDecimalKeyPress($event)" (input)="updateAmortizationRate($event)" placeholder="z.B. 2" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Anfängliche Tilgung in Prozent" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="monthlyRate">Kreditrate / Monat (€)
                <button type="button" class="info-btn" (click)="showTooltip('monthlyRate', $event)" aria-label="Hilfe zu Kreditrate">?</button>
                @if (monthlyRateNegativeAmortization()) {
                  <span style="color: #dc2626; margin-left: 0.25rem; cursor: pointer; font-size: 1.1rem;" (click)="showFieldWarning('monthlyRateNegativeAmortization', $event)" aria-label="Warnung: Kreditrate zu niedrig - Klicken für Details">⚠️</span>
                }
              </label>
              <input id="monthlyRate" type="text" [value]="monthlyRateDisplay()" (blur)="onMonthlyRateBlur($event)" (focus)="onCurrencyFocus($event)" (keypress)="onDecimalKeyPress($event)" (input)="updateMonthlyRate($event)" placeholder="z.B. 1.250,00" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Monatliche Kreditrate in Euro" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="interestBindingTerm">Zinsbindung (Jahre)
                <button type="button" class="info-btn" (click)="showTooltip('interestBindingTerm', $event)" aria-label="Hilfe zu Zinsbindung">?</button>
              </label>
              <input id="interestBindingTerm" type="text" [value]="interestBindingTermInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateInterestBindingTerm($event)" placeholder="z.B. 10" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Zinsbindung in Jahren" style="text-align: right; width: 100%;" />
            </div>
          </div>

          <!-- Jährliche Sondertilgung, Gesamt-Tilgung, Gesamt-Zinsen, Gesamtzahlung und Restschuld nebeneinander -->
          <div class="financing-grid">
            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="annualExtraRepayment">Jährliche Sondertilgung (€)
                <button type="button" class="info-btn" (click)="showTooltip('annualExtraRepayment', $event)" aria-label="Hilfe zu Sondertilgung">?</button>
              </label>
              <input id="annualExtraRepayment" type="text" [value]="annualExtraRepaymentInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateAnnualExtraRepayment($event)" (focus)="onCurrencyFocus($event)" (blur)="onAnnualExtraRepaymentBlur($event)" placeholder="z.B. 5.000" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Jährliche Sondertilgung in Euro" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="amortizationAmountYearly">Gesamt-Tilgung in Laufzeit (€)
                <button type="button" class="info-btn" (click)="showTooltip('totalAmortization', $event)" aria-label="Hilfe zu Gesamt-Tilgung">?</button>
              </label>
              <input id="amortizationAmountYearly" type="text" [value]="totalAmortizationOverLifetime()" readonly aria-label="Gesamt-Tilgung in Laufzeit in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="interestAmountDuringBinding">Gesamt-Zinsen in Laufzeit (€)
                <button type="button" class="info-btn" (click)="showTooltip('totalInterest', $event)" aria-label="Hilfe zu Gesamt-Zinsen">?</button>
              </label>
              <input id="interestAmountDuringBinding" type="text" [value]="totalInterestDuringBindingTerm()" readonly aria-label="Gesamt-Zinsen in Laufzeit in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="totalPaymentOverLifetime">Gesamtzahlung in Laufzeit (€)
                <button type="button" class="info-btn" (click)="showTooltip('totalPayment', $event)" aria-label="Hilfe zu Gesamtzahlung">?</button>
              </label>
              <input id="totalPaymentOverLifetime" type="text" [value]="totalPaymentOverLifetime()" readonly aria-label="Gesamtzahlung in Laufzeit in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="remainingDebtAfterBinding" style="margin-top: -2px;">Restschuld nach Zinsbind. (€)
                <button type="button" class="info-btn" (click)="showTooltip('remainingDebt', $event)" aria-label="Hilfe zu Restschuld">?</button>
                @if (isRemainingDebtNegative()) {
                  <span style="color: #dc2626; margin-left: 0.25rem; cursor: pointer; font-size: 1.1rem;" (click)="showFieldWarning('remainingDebtAfterBindingTerm', $event)" aria-label="Warnung: Negative Restschuld - Klicken für Details">⚠️</span>
                }
              </label>
              <input id="remainingDebtAfterBinding" type="text" [value]="remainingDebtAfterBindingTerm()" readonly aria-label="Restschuld nach Zinsbindung in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; margin-top: -2px;" />
            </div>
          </div>

          <!-- Gesamtkreditkosten in grün -->
          <div style="display: grid; grid-template-columns: 1fr; gap: 1rem; margin-bottom: 1rem;">
            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="totalCreditCost">Gesamt-Kreditkosten, inkl. Restschuld (€)
                <button type="button" class="info-btn" (click)="showTooltip('totalCreditCost', $event)" aria-label="Hilfe zu Gesamt-Kreditkosten">?</button>
              </label>
              <input id="totalCreditCost" type="text" [value]="totalCreditCostIncludingRemainingDebt()" readonly aria-label="Gesamt-Kreditkosten inklusive Restschuld in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; background-color: #f0fdf4 !important; border: 2px solid #86efac !important;" />
            </div>
          </div>

          <!-- Überschrift für Simulationsberechnung bei gleichbleibenden Zinsen -->
          <div style="margin-top: 1rem; margin-bottom: 0.5rem;">
            <h4 style="margin: 0; font-size: 0.95rem; font-weight: 600; color: var(--bright-blue);">Simulation Komplett-Tilgung bei <u style="color: #5B7C99;">gleichbleibenden</u> Zinsen nach Erst-Zinsbindung</h4>
          </div>

          <!-- Jahreszins effektiv, Kredit Rückzahlungsdauer, Gesamt-Zinsen und Gesamtzahlung bei gleichbleibenden Zinsen nebeneinander -->
          <div class="simulation-grid">
            <div class="form-group">
              <label for="interestRateSimulation">Jahreszins effektiv (%)
                @if (creditTermConstantRatesExceedsLimit()) {
                  <span style="color: #dc2626; margin-left: 0.25rem; cursor: pointer; font-size: 1.1rem;" (click)="showFieldWarning('creditTermExceedsLimit', $event)" aria-label="Warnung: Gesamtlaufzeit überschreitet 100 Jahre - Klicken für Details">⚠️</span>
                }
              </label>
              <input id="interestRateSimulation" type="text" [value]="interestRateInput()" readonly aria-label="Jahreszins effektiv in Prozent (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="creditTerm">Kredit Rückzahlungsdauer (Jahre)
                <button type="button" class="info-btn" (click)="showTooltip('creditTerm', $event)" aria-label="Hilfe zu Rückzahlungsdauer">?</button>
              </label>
              <input id="creditTerm" type="text" [value]="calculatedCreditTermDisplay()" readonly aria-label="Kredit Rückzahlungsdauer in Jahren (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="interestAmountYearly">Gesamt-Zinsen in Laufzeit (€)
                <button type="button" class="info-btn" (click)="showTooltip('totalInterest', $event)" aria-label="Hilfe zu Gesamt-Zinsen">?</button>
              </label>
              <input id="interestAmountYearly" type="text" [value]="totalInterestConstantRates()" readonly aria-label="Gesamt-Zinsen in Laufzeit in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="totalPaymentConstantRates">Gesamtzahlung in Laufzeit (€)
                <button type="button" class="info-btn" (click)="showTooltip('totalPayment', $event)" aria-label="Hilfe zu Gesamtzahlung">?</button>
              </label>
              <input id="totalPaymentConstantRates" type="text" [value]="totalPaymentOverLifetimeConstantRates()" readonly aria-label="Gesamtzahlung in Laufzeit in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; background-color: #f0fdf4 !important; border: 2px solid #86efac !important;" />
            </div>
          </div>

          <!-- Überschrift für Simulationsberechnung bei veränderten Zinsen -->
          <div style="margin-top: 1rem; margin-bottom: 0.5rem;">
            <h4 style="margin: 0; font-size: 0.95rem; font-weight: 600; color: var(--bright-blue);">Simulation Komplett-Tilgung bei <u style="color: #5B7C99;">veränderten</u> Zinsen nach Erst-Zinsbindung</h4>
          </div>

          <!-- Jahreszins effektiv, Kredit Rückzahlungsdauer, Gesamt-Zinsen und Gesamtzahlung bei veränderten Zinsen nebeneinander -->
          <div class="simulation-grid">
            <div class="form-group">
              <label for="changedInterestRateSimulation2" style="margin-top: -4px;">Veränderter Jahreszins effektiv (%)
                <button type="button" class="info-btn" (click)="showTooltip('changedInterestRate', $event)" aria-label="Hilfe zu verändertem Zinssatz">?</button>
                @if (isRemainingDebtZeroOrNegative()) {
                  <span style="color: #dc2626; margin-left: 0.25rem; cursor: pointer; font-size: 1.1rem;" (click)="showFieldWarning('changedInterestRateWarning', $event)" aria-label="Warnung: Keine Anschlusfinanzierung möglich - Klicken für Details">⚠️</span>
                }
                @if (creditTermChangedRatesExceedsLimit()) {
                  <span style="color: #dc2626; margin-left: 0.25rem; cursor: pointer; font-size: 1.1rem;" (click)="showFieldWarning('creditTermExceedsLimit', $event)" aria-label="Warnung: Gesamtlaufzeit überschreitet 100 Jahre - Klicken für Details">⚠️</span>
                }
              </label>
              <input id="changedInterestRateSimulation2" type="text" [value]="changedInterestRateInput()" [disabled]="isRemainingDebtZeroOrNegative()" (keypress)="onDecimalKeyPress($event)" (input)="updateChangedInterestRate($event)" placeholder="z.B. 3,8" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Veränderter Jahreszins effektiv in Prozent" class="price-per-sqm-field" style="text-align: right; background-color: white !important; border: 1px solid var(--bright-blue);" />
            </div>

            <div class="form-group">
              <label for="creditTermChanged2">Kredit Rückzahlungsdauer (Jahre)
                <button type="button" class="info-btn" (click)="showTooltip('creditTerm', $event)" aria-label="Hilfe zu Rückzahlungsdauer">?</button>
              </label>
              <input id="creditTermChanged2" type="text" [value]="calculatedCreditTermChangedRates()" readonly aria-label="Kredit Rückzahlungsdauer in Jahren (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="interestAmountYearlyChanged2">Gesamt-Zinsen in Laufzeit (€)
                <button type="button" class="info-btn" (click)="showTooltip('totalInterest', $event)" aria-label="Hilfe zu Gesamt-Zinsen">?</button>
              </label>
              <input id="interestAmountYearlyChanged2" type="text" [value]="totalInterestChangedRates()" readonly aria-label="Gesamt-Zinsen in Laufzeit in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="totalPaymentChangedRates2">Gesamtzahlung in Laufzeit (€)
                <button type="button" class="info-btn" (click)="showTooltip('totalPayment', $event)" aria-label="Hilfe zu Gesamtzahlung">?</button>
              </label>
              <input id="totalPaymentChangedRates2" type="text" [value]="totalPaymentOverLifetimeChangedRates()" readonly aria-label="Gesamtzahlung in Laufzeit in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; background-color: #f0fdf4 !important; border: 2px solid #86efac !important;" />
            </div>
          </div>
        </div>
      }
    </div>
    <!-- Finanzierungs-Kosten Help Section -->
    <div class="help-section" [class.collapsed]="!financingExpanded()">
      <h3 class="help-section-title">Finanzierungs-Kosten</h3>
      <div class="help-content">
        <p><strong>Kreditbedarf (€):</strong> Der zu finanzierende Betrag.</p>
        <p><strong>Jahreszins effektiv (%):</strong> Effektiver Jahreszins für das Darlehen, beinhaltet alle Kosten (Nominalzins plus Nebenkosten wie Bearbeitungsgebühren).</p>
        <p><strong>Anfängliche Tilgung (%):</strong> Jährliche Rückzahlungsquote. Sie können auch die monatliche Kreditrate eingeben, worauf die Tilgung automatisch berechnet wird.</p>
        <p><strong>Kreditrate / Monat (€):</strong> Monatliche Zahlungsrate. Sie können diesen Wert manuell eingeben, worauf die Tilgung automatisch berechnet wird.</p>
        <p><strong>Zinsbindung (Jahre):</strong> Zeitraum, in dem der Zinssatz gebunden ist.</p>
        <p><strong>Jährliche Sondertilgung (€):</strong> Zusätzliche Zahlung zur schnelleren Rückzahlung.</p>
        <p><strong>Gesamt-Tilgung in Laufzeit (€):</strong> Summe aller Tilgungszahlungen.</p>
        <p><strong>Gesamt-Zinsen in Laufzeit (€):</strong> Gesamte Zinskosten in der Bindungsperiode.</p>
        <p><strong>Gesamtzahlung in Laufzeit (€):</strong> Tilgung + Zinsen in der Bindungsperiode.</p>
        <p><strong>Restschuld nach Zinsbindung (€):</strong> Verbleibende Schuld nach Ende der Bindungsperiode.</p>
        <p><strong>Gesamt-Kreditkosten, inkl. Restschuld (€):</strong> Gesamte Kreditkosten einschließlich der verbleibenden Restschuld nach der Zinsbindungsperiode.</p>
        <p><strong style="color: var(--bright-blue);">Simulation (konstante Zinsen):</strong></p>
        <p><strong>Kredit Rückzahlungsdauer (Jahre):</strong> Geschätzte Gesamtdauer bei konstanten Zinssätzen.</p>
        <p><strong>Gesamt-Zinsen in Laufzeit (€):</strong> Gesamtzinskosten bei konstanten Zinssätzen.</p>
        <p><strong>Gesamtzahlung in Laufzeit (€):</strong> Gesamtsumme aller Zahlungen bei konstanten Zinssätzen.</p>
        <p><strong style="color: var(--bright-blue);">Simulation (veränderte Zinsen):</strong></p>
        <p><strong>Veränderter Jahreszins effektiv (%):</strong> Für Simulation mit verändertem Zinssatz nach der Erst-Zinsbindung.</p>
        <p><strong>Kredit Rückzahlungsdauer (Jahre):</strong> Geschätzte Gesamtdauer bei veränderten Zinssätzen.</p>
        <p><strong>Gesamt-Zinsen in Laufzeit (€):</strong> Gesamtzinskosten bei veränderten Zinssätzen.</p>
        <p><strong>Gesamtzahlung in Laufzeit (€):</strong> Gesamtsumme aller Zahlungen bei veränderten Zinssätzen.</p>
      </div>
    </div>
  </div>

  <!-- Section 6: Laufende Ausgaben - Form + Help in same wrapper -->
  <div class="section-wrapper">
    <div class="calculator-container" [style.min-height]="runningExpensesExpanded() ? '250px' : 'auto'">
      <button type="button" class="section-title" (click)="toggleRunningExpenses()" [class.collapsed]="!runningExpensesExpanded()">Laufende Ausgaben</button>
      @if (runningExpensesExpanded()) {
        <div>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(min(280px, 100%), 1fr)); gap: 1rem;">
            <div class="form-group">
              <label for="adminCosts">Verwaltungskosten / Jahr (€)</label>
              <input id="adminCosts" type="text" [value]="adminCostsInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateAdminCosts($event)" (focus)="onCurrencyFocus($event)" (blur)="onAdminCostsBlur($event)" placeholder="z.B. 1.000" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Verwaltungskosten pro Jahr in Euro" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="taxCosts">Steuern / Jahr (€)
                <button type="button" class="info-btn" (click)="showTooltip('taxCosts', $event)" aria-label="Hilfe zu Steuern">?</button>
              </label>
              <input id="taxCosts" type="text" [value]="taxCostsInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateTaxCosts($event)" (focus)="onCurrencyFocus($event)" (blur)="onTaxCostsBlur($event)" placeholder="z.B. 500" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Steuern pro Jahr in Euro" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="houseMoney">Hausgeld / Jahr (€)
                <button type="button" class="info-btn" (click)="showTooltip('houseMoney', $event)" aria-label="Hilfe zu Hausgeld">?</button>
              </label>
              <input id="houseMoney" type="text" [value]="houseMoneyInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateHouseMoney($event)" (focus)="onCurrencyFocus($event)" (blur)="onHouseMoneyBlur($event)" placeholder="z.B. 1.200" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Hausgeld pro Jahr in Euro" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="insurance">Versicherungen / Jahr (€)
                <button type="button" class="info-btn" (click)="showTooltip('insurance', $event)" aria-label="Hilfe zu Versicherungen">?</button>
              </label>
              <input id="insurance" type="text" [value]="insuranceInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateInsurance($event)" (focus)="onCurrencyFocus($event)" (blur)="onInsuranceBlur($event)" placeholder="z.B. 300" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Versicherungen pro Jahr in Euro" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="repairCosts">Reparaturen, Wartungskosten / Jahr (€)
                <button type="button" class="info-btn" (click)="showTooltip('repairCosts', $event)" aria-label="Hilfe zu Reparaturen">?</button>
              </label>
              <input id="repairCosts" type="text" [value]="repairCostsInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateRepairCosts($event)" (focus)="onCurrencyFocus($event)" (blur)="onRepairCostsBlur($event)" placeholder="z.B. 800" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Reparaturen und Wartungskosten pro Jahr in Euro" style="text-align: right;" />
            </div>

            <div class="form-group">
              <label for="otherExpenses">Sonstige Ausgaben / Jahr (€)</label>
              <input id="otherExpenses" type="text" [value]="otherExpensesInput()" (keypress)="onDecimalKeyPress($event)" (input)="updateOtherExpenses($event)" (focus)="onCurrencyFocus($event)" (blur)="onOtherExpensesBlur($event)" placeholder="z.B. 200" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" aria-label="Sonstige Ausgaben pro Jahr in Euro" style="text-align: right;" />
            </div>
          </div>
        </div>
      }
    </div>
    <!-- Laufende Ausgaben Help Section -->
    <div class="help-section" [class.collapsed]="!runningExpensesExpanded()" [style.min-height]="runningExpensesExpanded() ? '250px' : 'auto'">
      <h3 class="help-section-title">Laufende Ausgaben</h3>
      <div class="help-content">
        <p><strong>Verwaltungskosten:</strong> Hausverwaltung, Maklergebühren für Vermietung, etc.</p>
        <p><strong>Steuern:</strong> Grundsteuer und sonstige Immobiliensteuern pro Jahr.</p>
        <p><strong>Hausgeld:</strong> Nebenkosten, Betriebskosten für Gemeinschaftsflächen, Instandhaltungsrücklagen.</p>
        <p><strong>Versicherungen:</strong> Gebäudeversicherung, Haftpflicht, etc.</p>
        <p><strong>Reparaturen, Wartungskosten:</strong> Instandhaltung, Sanierung, regelmäßige Wartungen.</p>
        <p><strong>Sonstige Ausgaben:</strong> Weitere laufende Kosten, die nicht in anderen Kategorien erfasst sind.</p>
        <p>Diese Kosten beeinflussen die Rentabilität Ihrer Immobilieninvestition direkt.</p>
      </div>
    </div>
  </div>

  <!-- Section 7: Einnahmenüberschuß - Form + Help in same wrapper -->
  <div class="section-wrapper">
    <div class="calculator-container" [style.min-height]="amortisationExpanded() ? '280px' : 'auto'">
      <button type="button" class="section-title" (click)="toggleAmortisation()" [class.collapsed]="!amortisationExpanded()">Einnahmenüberschuß</button>
      @if (amortisationExpanded()) {
        <div>
          <!-- Monatliche Werte -->
          <div class="financing-grid">
            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="monthlyIncome">Einnahmen mtl. (€)</label>
              <input id="monthlyIncome" type="text" [value]="monthlyIncomeDisplay()" readonly aria-label="Einnahmen monatlich in Euro (schreibgeschützt)" class="total-income-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="monthlyFinancingExpenses">Kreditausgaben mtl. (€)</label>
              <input id="monthlyFinancingExpenses" type="text" [value]="monthlyFinancingExpensesDisplay()" readonly aria-label="Kreditausgaben monatlich in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="monthlyOtherExpenses">Lfd. Ausgaben mtl. (€)</label>
              <input id="monthlyOtherExpenses" type="text" [value]="monthlyOtherExpensesDisplay()" readonly aria-label="Laufende Ausgaben monatlich in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="monthlyTotalExpenses">Gesamtausgaben mtl. (€)</label>
              <input id="monthlyTotalExpenses" type="text" [value]="monthlyTotalExpensesDisplay()" readonly aria-label="Gesamtausgaben monatlich in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="monthlyIncomeExcess">Einnahmenüberschuß mtl. (€)</label>
              <input id="monthlyIncomeExcess" type="text" [value]="monthlyIncomeExcessDisplay()" readonly aria-label="Einnahmenüberschuß monatlich in Euro (schreibgeschützt)" [ngClass]="{'total-income-field': true, 'negative': isMonthlyIncomeExcessNegative()}" style="text-align: right; width: 100%;" />
            </div>
          </div>

          <!-- Jährliche Werte -->
          <div class="financing-grid">
            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="yearlyIncome">Einnahmen jährl. (€)</label>
              <input id="yearlyIncome" type="text" [value]="totalYearlyIncomeDisplay()" readonly aria-label="Einnahmen jährlich in Euro (schreibgeschützt)" class="total-income-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="yearlyFinancingExpenses">Kreditausgaben jährl. (€)</label>
              <input id="yearlyFinancingExpenses" type="text" [value]="yearlyFinancingExpensesDisplay()" readonly aria-label="Kreditausgaben jährlich in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="yearlyOtherExpenses">Lfd. Ausgaben jährl. (€)</label>
              <input id="yearlyOtherExpenses" type="text" [value]="yearlyOtherExpensesDisplay()" readonly aria-label="Laufende Ausgaben jährlich in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="yearlyTotalExpenses">Gesamtausgaben jährl. (€)</label>
              <input id="yearlyTotalExpenses" type="text" [value]="yearlyTotalExpensesDisplay()" readonly aria-label="Gesamtausgaben jährlich in Euro (schreibgeschützt)" class="price-per-sqm-field" style="text-align: right; width: 100%;" />
            </div>

            <div class="form-group" style="display: flex; flex-direction: column; min-width: 0;">
              <label for="yearlyIncomeExcess">Einnahmenüberschuß jährl. (€)</label>
              <input id="yearlyIncomeExcess" type="text" [value]="yearlyIncomeExcessDisplay()" readonly aria-label="Einnahmenüberschuß jährlich in Euro (schreibgeschützt)" [ngClass]="{'total-income-field': true, 'negative': isYearlyIncomeExcessNegative()}" style="text-align: right; width: 100%;" />
            </div>
          </div>
        </div>
      }
    </div>
    <!-- Einnahmenüberschuß Help Section -->
    <div class="help-section" [class.collapsed]="!amortisationExpanded()" [style.min-height]="amortisationExpanded() ? '280px' : 'auto'">
      <h3 class="help-section-title">Einnahmenüberschuß</h3>
      <div class="help-content">
        <p><strong>Einnahmen monatlich:</strong> Gesamte monatliche Einnahmen aus Vermietung oder anderen Quellen.</p>
        <p><strong>Kreditausgaben monatlich:</strong> Monatliche Rate für das Darlehen (Tilgung + Zinsen).</p>
        <p><strong>Laufende Ausgaben monatlich:</strong> Summe aller laufenden Ausgaben (Verwaltung, Steuern, Hausgeld, Versicherungen, Reparaturen, sonstige Kosten) pro Monat.</p>
        <p><strong>Gesamtausgaben monatlich:</strong> Summe aus Kreditausgaben und laufenden Ausgaben pro Monat.</p>
        <p><strong>Einnahmenüberschuß monatlich:</strong> Restbetrag nach Abzug aller Ausgaben. Positiv = Gewinn, Negativ = Verlust.</p>
      </div>
    </div>
  </div>

  <!-- Section 8: Amortisations-Szenarien Vergleich -->
  <div class="section-wrapper">
    <div class="calculator-container" [style.min-height]="scenariosExpanded() ? '400px' : 'auto'">
      <button type="button" class="section-title" (click)="toggleScenarios()" [class.collapsed]="!scenariosExpanded()">
        Amortisations-Szenarien Vergleich
        @if (shouldShowScenariosWarningIcon()) {
          <span style="color: #dc2626; margin-left: 0.5rem; cursor: pointer; font-size: 1.1rem;" (click)="showFieldWarning(scenariosWarningMessage(), $event)" aria-label="Warnung: Szenarien nicht berechnet - Klicken für Details">⚠️</span>
        }
      </button>
      @if (scenariosExpanded()) {
        <div class="scenarios-table">
          <table>
            <thead>
              <tr>
                <th>Kennzahl</th>
                <th>Variante 1: Restschuld nach Zinsbindung</th>
                <th>Variante 2: Komplett-Tilgung bei gleichbleibendem Zinssatz</th>
                <th>Variante 3: Komplett-Tilgung bei verändertem Zinssatz</th>
              </tr>
            </thead>
            <tbody>
              <tr class="scenario-info">
                <td><strong>Kreditlaufzeit (Jahre)</strong></td>
                <td>{{scenario1Duration()}}</td>
                <td>
                  @if (isScenario2Disabled()) { - } @else { {{scenario2Duration()}} }
                </td>
                <td>
                  @if (isScenario3Disabled()) { - } @else { {{scenario3Duration()}} }
                </td>
              </tr>
              <tr>
                <td><strong>Mieteinnahmen gesamt</strong></td>
                <td>{{formatNumberWithThousands(scenario1TotalIncome())}} €</td>
                <td>
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(scenario2TotalIncome())}} € }
                </td>
                <td>
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(scenario3TotalIncome())}} € }
                </td>
              </tr>
              <tr>
                <td><strong><span class="operator">−</span>Kreditkosten gesamt</strong></td>
                <td>{{formatNumberWithThousands(scenario1TotalCreditCost())}} €</td>
                <td>
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(scenario2TotalCreditCost())}} € }
                </td>
                <td>
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(scenario3TotalCreditCost())}} € }
                </td>
              </tr>
              <tr>
                <td><strong><span class="operator">−</span>Lfd. Ausgaben gesamt</strong></td>
                <td>{{formatNumberWithThousands(scenario1TotalRunningExpenses())}} €</td>
                <td>
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(scenario2TotalRunningExpenses())}} € }
                </td>
                <td>
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(scenario3TotalRunningExpenses())}} € }
                </td>
              </tr>
              <tr class="divider">
                <td><strong><span class="operator">=</span>Netto-Cashflow</strong></td>
                <td [class.positive]="scenario1NetCashflowIsPositive()" [class.negative]="!scenario1NetCashflowIsPositive()">{{formatNumberWithThousands(scenario1NetCashflow())}} €</td>
                <td>
                  @if (isScenario2Disabled()) {
                    -
                  } @else {
                    <span [class.positive]="scenario2NetCashflowIsPositive()" [class.negative]="!scenario2NetCashflowIsPositive()">{{formatNumberWithThousands(scenario2NetCashflow())}} €</span>
                  }
                </td>
                <td>
                  @if (isScenario3Disabled()) {
                    -
                  } @else {
                    <span [class.positive]="scenario3NetCashflowIsPositive()" [class.negative]="!scenario3NetCashflowIsPositive()">{{formatNumberWithThousands(scenario3NetCashflow())}} €</span>
                  }
                </td>
              </tr>
              <tr>
                <td style="display: flex; gap: 0.5rem; align-items: center;">
                  <strong>Immobilien-Wertsteigerung / jährl. (%)</strong>
                  <button type="button" class="ai-button" (click)="askAiAppreciationAllScenarios()" [disabled]="isLoadingAiAppreciationAllScenarios()" title="KI schätzt Wertsteigerung" aria-label="KI schätzt Wertsteigerung">
                    @if (isLoadingAiAppreciationAllScenarios()) { <span>⏳</span> } @else { <span>🤖</span> }
                  </button>
                </td>
                <td>
                  <input type="text" [value]="scenario1AppreciationRateInput()" (input)="updateScenario1AppreciationRate($event)" placeholder="2,0" pattern="[0-9]*(,[0-9]{1,2})?" inputmode="decimal" style="text-align: right; padding: 0.5rem; border: 1px solid #ccc; border-radius: 0.375rem; width: 100%; box-sizing: border-box;" />
                </td>
                <td>
                  @if (isScenario2Disabled()) {
                    -
                  } @else {
                    <input type="text" [value]="scenario2AppreciationRateInput()" (input)="updateScenario2AppreciationRate($event)" placeholder="2,0" pattern="[0-9]*(,[0-9]{1,2})?" inputmode="decimal" style="text-align: right; padding: 0.5rem; border: 1px solid #ccc; border-radius: 0.375rem; width: 100%; box-sizing: border-box;" />
                  }
                </td>
                <td>
                  @if (isScenario3Disabled()) {
                    -
                  } @else {
                    <input type="text" [value]="scenario3AppreciationRateInput()" (input)="updateScenario3AppreciationRate($event)" placeholder="2,0" pattern="[0-9]*(,[0-9]{1,2})?" inputmode="decimal" style="text-align: right; padding: 0.5rem; border: 1px solid #ccc; border-radius: 0.375rem; width: 100%; box-sizing: border-box;" />
                  }
                </td>
              </tr>
              <tr>
                <td><strong><span class="operator">+</span>Immobilienwert</strong></td>
                <td>{{formatNumberWithThousands(scenario1PropertyValue())}} €</td>
                <td>
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(scenario2PropertyValue())}} € }
                </td>
                <td>
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(scenario3PropertyValue())}} € }
                </td>
              </tr>
              <tr>
                <td><strong><span class="operator">−</span>Restschuld</strong></td>
                <td>{{formatNumberWithThousands(scenario1RemainingDebt())}} €</td>
                <td>
                  @if (isScenario2Disabled()) { - } @else { 0,00 € }
                </td>
                <td>
                  @if (isScenario3Disabled()) { - } @else { 0,00 € }
                </td>
              </tr>
              <tr>
                <td><strong><span class="operator">−</span>Investiertes Eigenkapital</strong></td>
                <td>{{formatNumberWithThousands(eigenkapitalInput())}} €</td>
                <td>
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(eigenkapitalInput())}} € }
                </td>
                <td>
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(eigenkapitalInput())}} € }
                </td>
              </tr>
              <tr class="total-row">
                <td><strong>GESAMT-ERGEBNIS</strong></td>
                <td [class.positive]="scenario1TotalResultIsPositive()" [class.negative]="!scenario1TotalResultIsPositive()">{{formatNumberWithThousands(scenario1TotalResult())}} €</td>
                <td>
                  @if (isScenario2Disabled()) {
                    -
                  } @else {
                    <span [class.positive]="scenario2TotalResultIsPositive()" [class.negative]="!scenario2TotalResultIsPositive()">{{formatNumberWithThousands(scenario2TotalResult())}} €</span>
                  }
                </td>
                <td>
                  @if (isScenario3Disabled()) {
                    -
                  } @else {
                    <span [class.positive]="scenario3TotalResultIsPositive()" [class.negative]="!scenario3TotalResultIsPositive()">{{formatNumberWithThousands(scenario3TotalResult())}} €</span>
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Accordion version for mobile -->
        <div class="scenarios-accordion">
          <!-- Variante 1 Accordion -->
          <div class="accordion-item" [ngClass]="{ expanded: scenarioAccordion1Expanded() }">
            <button type="button" class="accordion-header" (click)="toggleScenarioAccordion(1)">
              <span>
                Variante 1: Restschuld nach Zinsbindung
                <button type="button" class="info-btn" (click)="showTooltip('scenarios.variant1'); $event.stopPropagation()" aria-label="Hilfe zu Variante 1">?</button>
              </span>
            </button>
            <div class="accordion-content">
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>Kreditlaufzeit (Jahre)</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.duration1')" aria-label="Hilfe zu Kreditlaufzeit">?</button></span>
                <span class="accordion-row-value">{{scenario1Duration()}}</span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>Mieteinnahmen gesamt</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.totalIncome')" aria-label="Hilfe zu Mieteinnahmen gesamt">?</button></span>
                <span class="accordion-row-value">{{formatNumberWithThousands(scenario1TotalIncome())}} €</span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Kreditkosten gesamt</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.totalCreditCost')" aria-label="Hilfe zu Kreditkosten gesamt">?</button></span>
                <span class="accordion-row-value">{{formatNumberWithThousands(scenario1TotalCreditCost())}} €</span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Lfd. Ausgaben gesamt</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.runningExpenses')" aria-label="Hilfe zu Laufende Ausgaben gesamt">?</button></span>
                <span class="accordion-row-value">{{formatNumberWithThousands(scenario1TotalRunningExpenses())}} €</span>
              </div>
              <div class="accordion-row divider">
                <span class="accordion-row-label"><strong>=Netto-Cashflow</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.netCashflow')" aria-label="Hilfe zu Netto-Cashflow">?</button></span>
                <span class="accordion-row-value" [class.positive]="scenario1NetCashflowIsPositive()" [class.negative]="!scenario1NetCashflowIsPositive()">{{formatNumberWithThousands(scenario1NetCashflow())}} €</span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>Immobilien-Wertsteigerung / jährl. (%)</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.appreciationRate')" aria-label="Hilfe zu Immobilien-Wertsteigerung">?</button></span>
                <span class="accordion-row-value" style="display: flex; gap: 0.5rem; align-items: center;">
                  <input type="text" [value]="scenario1AppreciationRateInput()" (input)="updateScenario1AppreciationRate($event)" placeholder="2,0" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" style="text-align: right; padding: 0.25rem; border: 2px solid var(--bright-blue); background-color: #f0f9ff; border-radius: 0.375rem; width: 60px; box-sizing: border-box;" />
                  <button type="button" class="ai-button" (click)="askAiAppreciationAllScenarios()" [disabled]="isLoadingAiAppreciationAllScenarios()" title="KI schätzt Wertsteigerung" aria-label="KI schätzt Wertsteigerung für alle Szenarien">
                    @if (isLoadingAiAppreciationAllScenarios()) { <span>⏳</span> } @else { <span>🤖</span> }
                  </button>
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>+Immobilienwert</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.propertyValue')" aria-label="Hilfe zu Immobilienwert">?</button></span>
                <span class="accordion-row-value">{{formatNumberWithThousands(scenario1PropertyValue())}} €</span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Restschuld</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.remainingDebt1')" aria-label="Hilfe zu Restschuld">?</button></span>
                <span class="accordion-row-value">{{formatNumberWithThousands(scenario1RemainingDebt())}} €</span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Eigenkapital</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.equity')" aria-label="Hilfe zu Eigenkapital">?</button></span>
                <span class="accordion-row-value">{{formatNumberWithThousands(scenario1Equity())}} €</span>
              </div>
              <div class="accordion-row divider">
                <span class="accordion-row-label"><strong>GESAMT-ERGEBNIS</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.totalResult')" aria-label="Hilfe zu Gesamt-Ergebnis">?</button></span>
                <span class="accordion-row-value" [class.positive]="scenario1TotalResultIsPositive()" [class.negative]="!scenario1TotalResultIsPositive()">{{formatNumberWithThousands(scenario1TotalResult())}} €</span>
              </div>
            </div>
          </div>

          <!-- Variante 2 Accordion -->
          <div class="accordion-item" [ngClass]="{ expanded: scenarioAccordion2Expanded() }">
            <button type="button" class="accordion-header" (click)="toggleScenarioAccordion(2)">
              <span>
                Variante 2: Komplett-Tilgung bei gleichbleibendem Zinssatz
                <button type="button" class="info-btn" (click)="showTooltip('scenarios.variant2'); $event.stopPropagation()" aria-label="Hilfe zu Variante 2">?</button>
              </span>
            </button>
            <div class="accordion-content">
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>Kreditlaufzeit (Jahre)</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.duration2')" aria-label="Hilfe zu Kreditlaufzeit">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario2Disabled()) { - } @else { {{scenario2Duration()}} }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>Mieteinnahmen gesamt</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.totalIncome')" aria-label="Hilfe zu Mieteinnahmen gesamt">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(scenario2TotalIncome())}} € }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Kreditkosten gesamt</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.totalCreditCost')" aria-label="Hilfe zu Kreditkosten gesamt">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(scenario2TotalCreditCost())}} € }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Lfd. Ausgaben gesamt</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.runningExpenses')" aria-label="Hilfe zu Laufende Ausgaben gesamt">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(scenario2TotalRunningExpenses())}} € }
                </span>
              </div>
              <div class="accordion-row divider">
                <span class="accordion-row-label"><strong>=Netto-Cashflow</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.netCashflow')" aria-label="Hilfe zu Netto-Cashflow">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario2Disabled()) {
                    -
                  } @else {
                    <span [class.positive]="scenario2NetCashflowIsPositive()" [class.negative]="!scenario2NetCashflowIsPositive()">{{formatNumberWithThousands(scenario2NetCashflow())}} €</span>
                  }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>Immobilien-Wertsteigerung / jährl. (%)</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.appreciationRate')" aria-label="Hilfe zu Immobilien-Wertsteigerung">?</button></span>
                <span class="accordion-row-value" style="display: flex; gap: 0.5rem; align-items: center;">
                  @if (isScenario2Disabled()) {
                    -
                  } @else {
                    <input type="text" [value]="scenario2AppreciationRateInput()" (input)="updateScenario2AppreciationRate($event)" placeholder="2,0" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" style="text-align: right; padding: 0.25rem; border: 2px solid var(--bright-blue); background-color: #f0f9ff; border-radius: 0.375rem; width: 60px; box-sizing: border-box;" />
                    <button type="button" class="ai-button" (click)="askAiAppreciationAllScenarios()" [disabled]="isLoadingAiAppreciationAllScenarios()" title="KI schätzt Wertsteigerung" aria-label="KI schätzt Wertsteigerung für alle Szenarien">
                      @if (isLoadingAiAppreciationAllScenarios()) { <span>⏳</span> } @else { <span>🤖</span> }
                    </button>
                  }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>+Immobilienwert</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.propertyValue')" aria-label="Hilfe zu Immobilienwert">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(scenario2PropertyValue())}} € }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Restschuld</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.remainingDebt2')" aria-label="Hilfe zu Restschuld">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario2Disabled()) { - } @else { 0,00 € }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Eigenkapital</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.equity')" aria-label="Hilfe zu Eigenkapital">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario2Disabled()) { - } @else { {{formatNumberWithThousands(scenario2Equity())}} € }
                </span>
              </div>
              <div class="accordion-row divider">
                <span class="accordion-row-label"><strong>GESAMT-ERGEBNIS</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.totalResult')" aria-label="Hilfe zu Gesamt-Ergebnis">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario2Disabled()) {
                    -
                  } @else {
                    <span [class.positive]="scenario2TotalResultIsPositive()" [class.negative]="!scenario2TotalResultIsPositive()">{{formatNumberWithThousands(scenario2TotalResult())}} €</span>
                  }
                </span>
              </div>
            </div>
          </div>

          <!-- Variante 3 Accordion -->
          <div class="accordion-item" [ngClass]="{ expanded: scenarioAccordion3Expanded() }">
            <button type="button" class="accordion-header" (click)="toggleScenarioAccordion(3)">
              <span>
                Variante 3: Komplett-Tilgung bei verändertem Zinssatz
                <button type="button" class="info-btn" (click)="showTooltip('scenarios.variant3'); $event.stopPropagation()" aria-label="Hilfe zu Variante 3">?</button>
              </span>
            </button>
            <div class="accordion-content">
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>Kreditlaufzeit (Jahre)</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.duration3')" aria-label="Hilfe zu Kreditlaufzeit">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario3Disabled()) { - } @else { {{scenario3Duration()}} }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>Mieteinnahmen gesamt</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.totalIncome')" aria-label="Hilfe zu Mieteinnahmen gesamt">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(scenario3TotalIncome())}} € }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Kreditkosten gesamt</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.totalCreditCost')" aria-label="Hilfe zu Kreditkosten gesamt">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(scenario3TotalCreditCost())}} € }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Lfd. Ausgaben gesamt</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.runningExpenses')" aria-label="Hilfe zu Laufende Ausgaben gesamt">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(scenario3TotalRunningExpenses())}} € }
                </span>
              </div>
              <div class="accordion-row divider">
                <span class="accordion-row-label"><strong>=Netto-Cashflow</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.netCashflow')" aria-label="Hilfe zu Netto-Cashflow">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario3Disabled()) {
                    -
                  } @else {
                    <span [class.positive]="scenario3NetCashflowIsPositive()" [class.negative]="!scenario3NetCashflowIsPositive()">{{formatNumberWithThousands(scenario3NetCashflow())}} €</span>
                  }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>Immobilien-Wertsteigerung / jährl. (%)</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.appreciationRate')" aria-label="Hilfe zu Immobilien-Wertsteigerung">?</button></span>
                <span class="accordion-row-value" style="display: flex; gap: 0.5rem; align-items: center;">
                  @if (isScenario3Disabled()) {
                    -
                  } @else {
                    <input type="text" [value]="scenario3AppreciationRateInput()" (input)="updateScenario3AppreciationRate($event)" placeholder="2,0" pattern="[0-9]*([,][0-9]{1,2})?" inputmode="decimal" style="text-align: right; padding: 0.25rem; border: 2px solid var(--bright-blue); background-color: #f0f9ff; border-radius: 0.375rem; width: 60px; box-sizing: border-box;" />
                    <button type="button" class="ai-button" (click)="askAiAppreciationAllScenarios()" [disabled]="isLoadingAiAppreciationAllScenarios()" title="KI schätzt Wertsteigerung" aria-label="KI schätzt Wertsteigerung für alle Szenarien">
                      @if (isLoadingAiAppreciationAllScenarios()) { <span>⏳</span> } @else { <span>🤖</span> }
                    </button>
                  }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>+Immobilienwert</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.propertyValue')" aria-label="Hilfe zu Immobilienwert">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(scenario3PropertyValue())}} € }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Restschuld</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.remainingDebt3')" aria-label="Hilfe zu Restschuld">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario3Disabled()) { - } @else { 0,00 € }
                </span>
              </div>
              <div class="accordion-row">
                <span class="accordion-row-label"><strong>−Eigenkapital</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.equity')" aria-label="Hilfe zu Eigenkapital">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario3Disabled()) { - } @else { {{formatNumberWithThousands(scenario3Equity())}} € }
                </span>
              </div>
              <div class="accordion-row divider">
                <span class="accordion-row-label"><strong>GESAMT-ERGEBNIS</strong><button type="button" class="info-btn" (click)="showTooltip('scenarios.totalResult')" aria-label="Hilfe zu Gesamt-Ergebnis">?</button></span>
                <span class="accordion-row-value">
                  @if (isScenario3Disabled()) {
                    -
                  } @else {
                    <span [class.positive]="scenario3TotalResultIsPositive()" [class.negative]="!scenario3TotalResultIsPositive()">{{formatNumberWithThousands(scenario3TotalResult())}} €</span>
                  }
                </span>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <!-- Scenarios Help Section -->
    <div class="help-section" [class.collapsed]="!scenariosExpanded()" [style.min-height]="scenariosExpanded() ? '400px' : 'auto'">
      <h3 class="help-section-title">Szenarien-Vergleich</h3>
      <div class="help-content">
        <p><strong>Variante 1 - Restschuld:</strong> Simulation bis Ende der Zinsbindung. Restschuld bleibt bestehen.</p>
        <p><strong>Variante 2 - Bei gleichbleibendem Zinssatz:</strong> Komplette Tilgung mit unverändertem Zinssatz.</p>
        <p><strong>Variante 3 - Veränderter Zinssatz:</strong> Komplette Tilgung mit verändertem Zinssatz nach Erst-Zinsbindung.</p>
        <p style="margin-top: 1rem; padding: 0.5rem; background: #e3f2fd; border-left: 3px solid var(--bright-blue); border-radius: 4px;">
          <strong>Kennzahlen-Erklärung:</strong>
        </p>
        <p><strong>Kreditlaufzeit:</strong> Dauer bis zur vollständigen Tilgung (Variante 1: bis Ende Zinsbindung).</p>
        <p><strong>Mieteinnahmen gesamt:</strong> Summe aller Mieteinnahmen über die Kreditlaufzeit.</p>
        <p><strong>− Kreditkosten gesamt:</strong> Zinsen + Tilgung über die gesamte Laufzeit.</p>
        <p><strong>− Lfd. Ausgaben gesamt:</strong> Verwaltung, Steuern, Hausgeld, Versicherungen etc. über die Laufzeit.</p>
        <p><strong>= Netto-Cashflow:</strong> Mieteinnahmen minus alle Kosten (Kredit + lfd. Ausgaben).</p>
        <p><strong>🤖 Immobilien-Wertsteigerung / jährl. (%):</strong> Der KI-Button schätzt basierend auf Ihrer Adresse die jährliche Wertentwicklung der Immobilie und füllt automatisch alle 3 Szenarien mit dem gleichen Wert. Jedes Szenario kann bei Bedarf manuell einzeln angepasst werden.</p>
        <p><strong>+ Immobilienwert:</strong> Kaufpreis × (1 + Wertsteigerung/100)^Laufzeit</p>
        <p><strong>− Restschuld:</strong> Verbleibende Kreditschuld am Ende der Laufzeit (Variante 1 nach Zinsbindung).</p>
        <p><strong>− Investiertes Eigenkapital:</strong> Ihr eingesetztes Eigenkapital (wird abgezogen, da es Ihre Investition war).</p>
        <p><strong>= Gesamt-Ergebnis:</strong> Netto-Cashflow + Immobilienwert − Restschuld − Eigenkapital = Ihr Vermögenszuwachs (inkl. Eigenkapital).</p>
        <div style="margin-top: 1rem; display: flex; gap: 1rem;">
          <p style="padding: 0.5rem; background: #e8f5e9; border-left: 3px solid #4caf50; border-radius: 4px; margin: 0;">
            <strong>Grün</strong> = Gewinn
          </p>
          <p style="padding: 0.5rem; background: #ffebee; border-left: 3px solid #f44336; border-radius: 4px; margin: 0;">
            <strong>Rot</strong> = Verlust
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Save and Load Dialogs -->
  <app-save-calculation-dialog></app-save-calculation-dialog>
  <app-load-calculation-dialog></app-load-calculation-dialog>

  <!-- Toast Notification -->
  @if (toastMessage()) {
    <div class="toast" [class]="toastMessage()!.type">
      {{ toastMessage()!.text }}
    </div>
  }

  <!-- Field Warning Toast Modal -->
  @if (activeWarning()) {
    <div class="warning-overlay active" (click)="hideFieldWarning()">
      <div class="warning-content" (click)="$event.stopPropagation()">
        <div class="warning-header">
          <h3 class="warning-title">⚠️ Warnung</h3>
          <button type="button" class="warning-close" (click)="hideFieldWarning()" aria-label="Schließen">×</button>
        </div>
        <div class="warning-text">
          @switch (activeWarning()) {
            @case ('remainingDebtAfterBindingTerm') {
              <div [innerHTML]="fieldWarnings.remainingDebtAfterBindingTerm.content"></div>
            }
            @case ('changedInterestRateWarning') {
              <div [innerHTML]="fieldWarnings.changedInterestRateWarning.content"></div>
            }
            @case ('scenariosWarning') {
              <div [innerHTML]="fieldWarnings.scenariosWarning.content"></div>
            }
            @case ('scenariosWarning_Scenario3Over100Years') {
              <div [innerHTML]="fieldWarnings.scenariosWarning_Scenario3Over100Years.content"></div>
            }
            @case ('scenariosWarning_Scenario2Over100Years') {
              <div [innerHTML]="fieldWarnings.scenariosWarning_Scenario2Over100Years.content"></div>
            }
            @case ('creditTermExceedsLimit') {
              <div [innerHTML]="fieldWarnings.creditTermExceedsLimit.content"></div>
            }
            @case ('monthlyRateNegativeAmortization') {
              <div>Die eingegebene Kreditrate ist zu niedrig und führt zu einer negativen Tilgung. Bitte erhöhen Sie die Kreditrate / Monat (€).</div>
            }
          }
        </div>
      </div>
    </div>
  }

  <!-- Mobile Tooltip Overlay -->
  @if (activeTooltip()) {
    <div class="tooltip-overlay active" (click)="hideTooltip()">
      <div class="tooltip-content" (click)="$event.stopPropagation()">
        <div class="tooltip-header">
          <h3 class="tooltip-title">Hilfe</h3>
          <button type="button" class="tooltip-close" (click)="hideTooltip()" aria-label="Schließen">×</button>
        </div>
        <div class="tooltip-text">
          @switch (activeTooltip()) {
            <!-- Adressdaten -->
            @case ('country') {
              <div [innerHTML]="helpTexts.addressData.content.country"></div>
            }
            @case ('city') {
              <div [innerHTML]="helpTexts.addressData.content.city"></div>
            }
            @case ('address') {
              <div [innerHTML]="helpTexts.addressData.content.address"></div>
            }
            @case ('postalCode') {
              <div [innerHTML]="helpTexts.addressData.content.postalCode"></div>
            }
            
            <!-- Kaufkosten -->
            @case ('purchasePrice') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.purchasePrice"></div>
            }
            @case ('agentCosts') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.agentCosts"></div>
            }
            @case ('agentCostsPercentage') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.agentCostsPercentage"></div>
            }
            @case ('notaryCosts') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.notaryCosts"></div>
            }
            @case ('notaryCostsPercentage') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.notaryCostsPercentage"></div>
            }
            @case ('landRegistryCosts') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.landRegistryCosts"></div>
            }
            @case ('landRegistryCostsPercentage') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.landRegistryCostsPercentage"></div>
            }
            @case ('acquisitionTax') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.acquisitionTax"></div>
            }
            @case ('acquisitionTaxPercentage') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.acquisitionTaxPercentage"></div>
            }
            @case ('eigenkapital') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.eigenkapital"></div>
            }
            @case ('kreditbedarf') {
              <div [innerHTML]="helpTexts.purchaseCosts.content.kreditbedarf"></div>
            }
            
            <!-- Objekt-Einnahmen -->
            @case ('objectSize') {
              <div [innerHTML]="helpTexts.objectIncome.content.objectSize"></div>
            }
            @case ('constructionYear') {
              <div [innerHTML]="helpTexts.objectIncome.content.constructionYear"></div>
            }
            @case ('rentalPrice') {
              <div [innerHTML]="helpTexts.objectIncome.content.rentalPrice"></div>
            }
            @case ('monthlyRentalPrice') {
              <div [innerHTML]="helpTexts.objectIncome.content.monthlyRentalPrice"></div>
            }
            @case ('yearlyRentalPrice') {
              <div [innerHTML]="helpTexts.objectIncome.content.yearlyRentalPrice"></div>
            }
            @case ('additionalMonthlyIncome') {
              <div [innerHTML]="helpTexts.objectIncome.content.additionalMonthlyIncome"></div>
            }
            
            <!-- Finanzierung -->
            @case ('kreditbedarf') {
              <div [innerHTML]="helpTexts.financing.content.kreditbedarf"></div>
            }
            @case ('interestRate') {
              <div [innerHTML]="helpTexts.financing.content.interestRate"></div>
            }
            @case ('amortizationRate') {
              <div [innerHTML]="helpTexts.financing.content.amortizationRate"></div>
            }
            @case ('monthlyRate') {
              <div [innerHTML]="helpTexts.financing.content.monthlyRate"></div>
            }
            @case ('interestBindingTerm') {
              <div [innerHTML]="helpTexts.financing.content.interestBindingTerm"></div>
            }
            @case ('annualExtraRepayment') {
              <div [innerHTML]="helpTexts.financing.content.annualExtraRepayment"></div>
            }
            @case ('totalAmortization') {
              <div [innerHTML]="helpTexts.financing.content.totalAmortization"></div>
            }
            @case ('totalInterest') {
              <div [innerHTML]="helpTexts.financing.content.totalInterest"></div>
            }
            @case ('totalPayment') {
              <div [innerHTML]="helpTexts.financing.content.totalPayment"></div>
            }
            @case ('remainingDebt') {
              <div [innerHTML]="helpTexts.financing.content.remainingDebt"></div>
            }
            @case ('creditTerm') {
              <div [innerHTML]="helpTexts.financing.content.creditTerm"></div>
            }
            @case ('changedInterestRate') {
              <div [innerHTML]="helpTexts.financing.content.changedInterestRate"></div>
            }
            @case ('totalCreditCost') {
              <div [innerHTML]="helpTexts.financing.content.totalCreditCost"></div>
            }
            
            <!-- Laufende Ausgaben -->
            @case ('adminCosts') {
              <div [innerHTML]="helpTexts.runningExpenses.content.adminCosts"></div>
            }
            @case ('taxCosts') {
              <div [innerHTML]="helpTexts.runningExpenses.content.taxCosts"></div>
            }
            @case ('houseMoney') {
              <div [innerHTML]="helpTexts.runningExpenses.content.houseMoney"></div>
            }
            @case ('insurance') {
              <div [innerHTML]="helpTexts.runningExpenses.content.insurance"></div>
            }
            @case ('repairCosts') {
              <div [innerHTML]="helpTexts.runningExpenses.content.repairCosts"></div>
            }
            @case ('otherExpenses') {
              <div [innerHTML]="helpTexts.runningExpenses.content.otherExpenses"></div>
            }
            
            <!-- Szenarien-Vergleich -->
            @case ('scenarios.variant1') {
              <div [innerHTML]="helpTexts.scenarios.content.variant1"></div>
            }
            @case ('scenarios.variant2') {
              <div [innerHTML]="helpTexts.scenarios.content.variant2"></div>
            }
            @case ('scenarios.variant3') {
              <div [innerHTML]="helpTexts.scenarios.content.variant3"></div>
            }
            @case ('scenarios.duration1') {
              <div [innerHTML]="helpTexts.scenarios.content.duration1"></div>
            }
            @case ('scenarios.duration2') {
              <div [innerHTML]="helpTexts.scenarios.content.duration2"></div>
            }
            @case ('scenarios.duration3') {
              <div [innerHTML]="helpTexts.scenarios.content.duration3"></div>
            }
            @case ('scenarios.totalIncome') {
              <div [innerHTML]="helpTexts.scenarios.content.totalIncome"></div>
            }
            @case ('scenarios.totalCreditCost') {
              <div [innerHTML]="helpTexts.scenarios.content.totalCreditCost"></div>
            }
            @case ('scenarios.runningExpenses') {
              <div [innerHTML]="helpTexts.scenarios.content.runningExpenses"></div>
            }
            @case ('scenarios.netCashflow') {
              <div [innerHTML]="helpTexts.scenarios.content.netCashflow"></div>
            }
            @case ('scenarios.appreciationRate') {
              <div [innerHTML]="helpTexts.scenarios.content.appreciationRate"></div>
            }
            @case ('scenarios.propertyValue') {
              <div [innerHTML]="helpTexts.scenarios.content.propertyValue"></div>
            }
            @case ('scenarios.remainingDebt1') {
              <div [innerHTML]="helpTexts.scenarios.content.remainingDebt1"></div>
            }
            @case ('scenarios.remainingDebt2') {
              <div [innerHTML]="helpTexts.scenarios.content.remainingDebt2"></div>
            }
            @case ('scenarios.remainingDebt3') {
              <div [innerHTML]="helpTexts.scenarios.content.remainingDebt3"></div>
            }
            @case ('scenarios.equity') {
              <div [innerHTML]="helpTexts.scenarios.content.equity"></div>
            }
            @case ('scenarios.totalResult') {
              <div [innerHTML]="helpTexts.scenarios.content.totalResult"></div>
            }
          }
        </div>
      </div>
    </div>
  }

  </div>

</main>

<!-- Dialogs -->
<app-save-calculation-dialog></app-save-calculation-dialog>
<app-load-calculation-dialog></app-load-calculation-dialog>
<app-rename-calculation-dialog></app-rename-calculation-dialog>
<app-delete-confirmation-dialog></app-delete-confirmation-dialog>
<app-duplicate-calculation-dialog></app-duplicate-calculation-dialog>
<app-export-calculation-dialog></app-export-calculation-dialog>
<app-export-comparison-dialog></app-export-comparison-dialog>

<app-subscription-expired-modal></app-subscription-expired-modal>

<app-footer></app-footer>